import {AppActions, useAppContext} from "../../context/AppContext";
import {useUser} from "../../context/UserContext";
import {useMapSync} from "../../context/MapSyncContext";
import 'leaflet-arrowheads';
import 'leaflet-polylinedecorator';
import 'leaflet-simple-map-screenshoter'
import 'leaflet-control-mini-map/dist/minimap.css';
import 'leaflet-measure'
import 'leaflet-measure/dist/leaflet-measure.css'
import 'leaflet-kmz'
import 'leaflet-geometryutil'
import 'leaflet-draw'
import 'leaflet-snap'
import 'leaflet.markercluster'
import 'leaflet-search'
import 'leaflet-search/dist/leaflet-search.min.css'
import 'leaflet/dist/images/marker-icon-2x.png'

import _ from 'lodash'
import {SimpleMapScreenshoter} from 'leaflet-simple-map-screenshoter'
import {useEffect, useRef, useState} from "react";
import {useModal} from "../../context/ModalContext";
import {v4} from "uuid";
import KML from "../map-plugins/KML";
import MouseCoord from "../map-plugins/MouseCoord";
import proj4 from "proj4";
import MeasureTool from "../map-plugins/MeasureTool";
import FullExtend from "../map-plugins/FullExtend";
import TileSelect from "../map-plugins/TileSelect";
import ProfileSelect from "../map-plugins/ProfileSelect";
import {MapContainer} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'
// Vector-tile decoders: used to fetch + decode ArcGIS .pbf tiles client-side so a
// vector-tile-only layer (NC Non-Encroachment Areas) can be loaded ONCE for the
// project bounding box and rendered as a single static GeoJSON overlay.
import { PbfReader } from 'pbf';
import { VectorTile } from '@mapbox/vector-tile';
import {notification, Space, Spin, Progress} from "antd";
import '@meteo-concept/leaflet-inflatable-markers-group';
import '../../styles/map-view.css'
import CrossSectionWindow from "../outputs/ui/CrossSection/CrossSectionWindow";
import ReactDOMServer from 'react-dom/server';
import {BridgeTable, CulvertTable, BridgeInfoTable, CulvertInfoTable, InlineStructureInfoTable, StructureInfoTabs} from "../outputs/internal/B40";
import ShapeFileHelper from "../../helpers/ShapeFileHelper";
import ShapeItem, {ShapeTooltip, getLayerHoverLabel} from "./ShapeItem";
import StructureName from "../map-plugins/StructureName";
import MapProjectInfo from "../map-plugins/MapProjectInfo";
import createLeafletPopup from "../../components/CreateLeafletPopup";
import FlowChangeTable from "./FlowChangeTable";
import HecRasHelper from "../../helpers/HecRasHelper";
import BoundaryTable from "./BoundaryTable";
import LayerSearch from "../map-plugins/LayerSearch";
import ResultTable from "../../components/table/ResultTable";
import ResultRow from "../../components/table/ResultRow";
import ResultHeaderCell from "../../components/table/ResultHeaderCell";
import LayerSelectLeaflet from "../map-plugins/LayerSelectLeaflet";
import {createRoot} from 'react-dom/client';
import ShapeTable from "./ShapeTable";
import ResultBodyCell from "../../components/table/ResultBodyCell";
import GeoRasterLayer from "georaster-layer-for-leaflet";
import parseGeoraster from 'georaster'
import MapTypeSwitchButton from "../map-plugins/MapTypeSwitch";
import ProjectionSelect from "../map-plugins/ProjectionSelect";
import {DEFAULT_PROJECTION, loadProjectionText, getProjectionLabel, findProjectionKeyByText, ensureProjectionsLoaded} from "../../helpers/ProjectionHelper";
import ApiService from "../../services/ApiService";

// leaflet-arrowheads crashes during teardown: when an arrowheaded polyline (the
// river) is removed while its _map is already null — e.g. react-leaflet's
// MapContainer running map.remove() on unmount, which fires BEFORE our own
// cleanup — Leaflet's removeInteractiveTarget dereferences this._map._targets
// and throws "Cannot read properties of null (reading '_targets')". Guard it at
// the source (runs once) so every teardown path is covered.
if (L?.Layer?.prototype && !L.Layer.prototype.__ritNullGuard) {
    const _origRemoveInteractiveTarget = L.Layer.prototype.removeInteractiveTarget;
    L.Layer.prototype.removeInteractiveTarget = function (targetEl) {
        if (!this._map) return this;
        return _origRemoveInteractiveTarget.call(this, targetEl);
    };
    L.Layer.prototype.__ritNullGuard = true;
}


const getTiles = () => {
    return [
        {tile: 'Google Street', url: 'http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', options: {subdomains:['mt0','mt1','mt2','mt3'], maxZoom: 25}, textColor: 'black', csColor: 'green', structure: '#808080'},
        {tile: 'Google Hybrid', url: 'http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', options: {subdomains:['mt0','mt1','mt2','mt3'], maxZoom: 25}, textColor: 'white', csColor: '#39FF14', structure: 'yellow'},
        {tile: 'Google Satellite', url: 'http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', options: {subdomains:['mt0','mt1','mt2','mt3'], maxZoom: 25}, textColor: 'white', csColor: '#39FF14', structure: 'yellow'},
        {tile: 'Google Terrain', url: 'http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', options: {subdomains:['mt0','mt1','mt2','mt3'], maxZoom: 25}, textColor: 'black', csColor: 'green', structure: '#808080'},
        {tile: 'USGS The National Map (TNM)', url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}', options: {maxZoom: 25}, textColor: 'black', csColor: 'green', structure: '#808080'},
        {tile: 'USGS Imagery Only', url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}', options: {maxZoom: 25}, textColor: 'white', csColor: '#39FF14', structure: 'yellow'},
        {tile: 'USGS Topo', url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}', options: {maxZoom: 25}, textColor: 'white', csColor: '#39FF14', structure: 'yellow'},
        {tile: 'OpenStreetMap', url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        // {tile: 'ArcGIS USA Topo', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/USA_Topo_Maps/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        {tile: 'ArcGIS World Street Map', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        {tile: 'ArcGIS World Imagery', url: 'https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', textColor: 'white', csColor: '#39FF14', options: {maxZoom: 25}, structure: 'yellow'},
        // {tile: 'ArcGIS NatGeo World Map', url: 'https://services.arcgisonline.com/arcgis/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}\n', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        // {tile: 'ArcGIS Physical World Map', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Physical_Map/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        // {tile: 'ArcGIS World Shaded Relief', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        // {tile: 'ArcGIS World Terrain Base', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Terrain_Base/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        {tile: 'ArcGIS World Topo Map', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        {tile: 'ArcGIS USA', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', textColor: 'black', csColor: 'green', options: {maxZoom: 25}, structure: '#808080'},
        {tile: 'None', url: '', options: {maxZoom: 25}, textColor: 'black', csColor: 'green', structure: '#808080', isBlank: true},
    ]
}

const getCenter = (coords) => {
    let sum_x = 0;
    let sum_y = 0;

    for (const coord of coords) {
        sum_x += coord[0]
        sum_y += coord[1]
    }

    return [sum_x/coords.length, sum_y/coords.length]
}


export default function MapView({type, currentMapType, projection, filter, projectInfo, updateKey, mapData, projectLayers, onProjectLayerChange, riverBoundingCoords, selectedRS, mapSize, highlightSurvey = [], onTypeChange, hasCompareData, onMapReady, isSideBySide, controlPosition = 'topleft', sharedTile, onSharedTileChange, isVisible = true}) {
    const {dispatchProject, mapContext} = useAppContext()
    const {user, setSettings} = useUser()
    const { setSharedView, getSharedView } = useMapSync()
    
    // Determine which type to show on the button (sidebyside when in side-by-side mode)
    const buttonType = currentMapType || type
    
    // Model layers userSettings'ten oku
    const modelLayers = user?.settings?.map_settings?.model_layers || mapContext[type]?.selectedLayers?.model || []
    
    // Get user preference projection
    const userPreferenceProjection = user?.settings?.defaults?.spatial_projection || DEFAULT_PROJECTION
    
    // Determine effective projection: project projection if available, otherwise user preference
    const getEffectiveProjection = async () => {
        await ensureProjectionsLoaded()
        if (projection) {
            // Try to detect the actual projection name from WKT
            const detectedKey = findProjectionKeyByText(projection)
            const projName = detectedKey ? getProjectionLabel(detectedKey) : 'Custom'
            return { text: projection, name: projName, isProject: true }
        }
        // Load user preference projection
        const projText = userPreferenceProjection ? await loadProjectionText(userPreferenceProjection) : null
        if (projText) {
            return { text: projText, name: getProjectionLabel(userPreferenceProjection), isProject: false }
        }
        return { text: null, name: 'None', isProject: false }
    }
    
    // Get initial projection name
    const getInitialProjectionName = () => {
        if (!projection) return getProjectionLabel(DEFAULT_PROJECTION)
        const detectedKey = findProjectionKeyByText(projection)
        return detectedKey ? getProjectionLabel(detectedKey) : 'Custom'
    }
    
    const [map, setMap] = useState(null)
    const [activeProjection, setActiveProjection] = useState({ text: projection, name: getInitialProjectionName(), isProject: !!projection })
    const mouseCoordRef = useRef(null)
    const isReady = useRef(false)
    const typeRef = useRef(type)
    const [size, setSize] = useState(mapSize || {height: '100%', width: '100%'})
    const {openModal, closeModal} = useModal()
    const [localTile, setLocalTile] = useState(getTiles()[0])
    
    // FEMA loading progress state
    const [femaProgress, setFemaProgress] = useState(null)
    
    // Use shared tile if provided, otherwise use local tile
    const tile = sharedTile || localTile
    const setTile = onSharedTileChange || setLocalTile
    
    const tileRef = useRef(tile)
    const [profile, setProfile] = useState(null)
    const prevSelectedRS = useRef(selectedRS?.cross_section)
    const [fullExtendEvent, setFullExtendEvent] = useState(null)
    const mapObjects = useRef({
        tile: null,
        river: null,
        flow_path_left: null,
        flow_path_right: null,
        streamArrow: null,
        banks: [],
        banksLayer: null,
        mannings: [],
        manningsTexts: [],
        manningsLayer: null,
        manningsTextLayer: null,
        ineffs: [],
        ineffLayer: null,
        crossSections: [],
        crossSectionTexts: [],
        crossSectionLayer: null,
        crossSectionTextLayer: null,
        flowChanges: [],
        flowChangeLayer: null,
        downstreamBoundary: null,
        blockObst: [],
        blockObstLayer: null,
        riverStationPoints: [],
        riverStationPointLayer: null,
        structures: [],
        structureLayer: null,
        structureTexts: [],
        structureTextLayer: null,
        multipleOpeningLines: [],
        multipleOpeningLinesLayer: null,
        floodExtends: [],
        floodExtendsLayer: null,
        referenceLayers: [],
        projectLayers: [],
        drawControl: null,
        plugins: [],
        searchLayer: null,
        textLayer: null,
        loadLayerTimeout: null,
        layerSelectRoot: null,
        layerSelectControl: null,
        projectionSelectRoot: null,
        projectionSelectControl: null
    })

    const handleResize = () => {
        // mapSize verilmeyen (tek harita) modda boyut CSS %100 ile ebeveyne oturur;
        // sadece leaflet'in ic boyut onbellegini tazelemek yeterli.
        if (!mapSize) {
            try { map && map.invalidateSize() } catch (e) {}
            return
        }
        setSize({
            width: window.innerWidth-32,
            height: window.innerHeight-125,
        })
    }

    const fullExtend = async (e) => {
        try {
            const data = await ShapeFileHelper.getBounding(riverBoundingCoords, mapContext[type]?.bounding)

            map?.fitBounds([
                data[1],
                data[3],
            ])
        }
        catch (exp) {
            console.log(exp)
        }
    }

    const getColor = (csName, type, defColor) => {
        if(filter) {
            const inFilter = HecRasHelper.inFilter({us: filter?.us, ds: filter?.ds, cs_name: csName})
            if(type === 'text' && inFilter) {
                return '#00a8ff'
            }
            if(type === 'cross_section' && inFilter) {
                return '#00a8ff'
            }
            if(type === 'structure' && inFilter) {
                return '#00a8ff'
            }
        }

        return defColor
    }

    const loadPlugins = () => {
        if(mapObjects.current.plugins.length > 0) {
            return
        }

        window.guideLayers = []
        // Use effective projection (project if available, otherwise user preference)
        const projText = activeProjection?.text || projection
        const projName = activeProjection?.name || 'Unknown'
        const isProjectProjection = activeProjection?.isProject || false
        mouseCoordRef.current = MouseCoord(L, projText, proj4, map, projName)
        mouseCoordRef.current.updateProjection(projText, projName, isProjectProjection)
        MapProjectInfo(L, type, map)
        FullExtend(L, type)
        KML(L)

        MeasureTool(L, map)
        const Ruler = L.Control.LinearMeasurement.extend({
            layerSelected: function(e){}
        });
        mapObjects.current.plugins.push(map.addControl(new Ruler({
            unitSystem: 'imperial',
            color: '#04d9ff',
            show_azimut: false,
            position: controlPosition
        })))

        map.removeControl(map.zoomControl);
        mapObjects.current.plugins.push(L.control.fullExtend({position: controlPosition}).addTo(map));

        map.on(L.Draw.Event.CREATED, function (e) {

        });

        const ss = new SimpleMapScreenshoter({preventDownload: true, position: controlPosition}).addTo(map)
        mapObjects.current.plugins.push(ss)
        const ssInterval = setInterval(() => {
            const ssButton = document.getElementsByClassName('leaflet-control-simpleMapScreenshoter-btn')[0]
            if(ssButton) {
                ssButton.onclick = (e) => {
                    ss.takeScreen('blob', {
                        mimeType: 'image/png'
                    }).then(async blob => {
                        await navigator.clipboard.write([
                            new window.ClipboardItem({ "image/png": blob })
                        ]);

                        notification.success({
                            message: 'Image is copied to clipboard!'
                        })
                    })
                }

                clearInterval(ssInterval)
            }
        }, 100)

        // LayerSelect Control - Leaflet Control olarak ekleniyor
        const LayerSelectControl = L.Control.extend({
            options: {
                position: controlPosition
            },
            onAdd: function(leafletMap) {
                const container = L.DomUtil.create('div');
                
                L.DomEvent.disableClickPropagation(container);
                L.DomEvent.disableScrollPropagation(container);
                
                mapObjects.current.layerSelectRoot = createRoot(container);
                mapObjects.current.layerSelectRoot.render(
                    <LayerSelectLeaflet
                        type={type}
                        projectLayers={projectLayers}
                        onProjectLayerChange={onProjectLayerChange}
                        riverBounding={riverBoundingCoords}
                        mapContext={mapContext}
                        dispatchProject={dispatchProject}
                        ShapeTableComponent={ShapeTable}
                        openModal={openModal}
                        userSettings={user?.settings}
                        user={user}
                        setSettings={setSettings}
                        isSideBySide={isSideBySide}
                    />
                );
                
                return container;
            },
            onRemove: function(leafletMap) {
                if (mapObjects.current.layerSelectRoot) {
                    const root = mapObjects.current.layerSelectRoot;
                    mapObjects.current.layerSelectRoot = null;
                    setTimeout(() => root.unmount(), 0);
                }
            }
        });
        mapObjects.current.layerSelectControl = new LayerSelectControl().addTo(map);

        // ProjectionSelect Control - Projeksiyon değiştirme için
        const ProjectionSelectControl = L.Control.extend({
            options: {
                position: 'bottomleft'
            },
            onAdd: function(leafletMap) {
                const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
                
                L.DomEvent.disableClickPropagation(container);
                L.DomEvent.disableScrollPropagation(container);
                
                mapObjects.current.projectionSelectRoot = createRoot(container);
                mapObjects.current.projectionSelectRoot.render(
                    <ProjectionSelect
                        projectProjection={projection}
                        activeProjection={activeProjection}
                        onProjectionChange={setActiveProjection}
                        userPreference={userPreferenceProjection}
                    />
                );
                
                return container;
            },
            onRemove: function(leafletMap) {
                if (mapObjects.current.projectionSelectRoot) {
                    const root = mapObjects.current.projectionSelectRoot;
                    mapObjects.current.projectionSelectRoot = null;
                    setTimeout(() => root.unmount(), 0);
                }
            }
        });
        mapObjects.current.projectionSelectControl = new ProjectionSelectControl().addTo(map);

        // MapTypeSwitch Control - Base/Compare/SideBySide geçişi için
        if(onTypeChange) {
            const MapTypeSwitchControl = L.Control.extend({
                options: {
                    position: controlPosition
                },
                onAdd: function(leafletMap) {
                    const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
                    
                    L.DomEvent.disableClickPropagation(container);
                    L.DomEvent.disableScrollPropagation(container);
                    
                    mapObjects.current.mapTypeSwitchRoot = createRoot(container);
                    mapObjects.current.mapTypeSwitchRoot.render(
                        <MapTypeSwitchButton 
                            currentType={buttonType} 
                            onTypeChange={onTypeChange} 
                            hasCompareData={hasCompareData}
                        />
                    );
                    
                    return container;
                },
                onRemove: function(leafletMap) {
                    if (mapObjects.current.mapTypeSwitchRoot) {
                        const root = mapObjects.current.mapTypeSwitchRoot;
                        mapObjects.current.mapTypeSwitchRoot = null;
                        setTimeout(() => root.unmount(), 0);
                    }
                }
            });
            mapObjects.current.mapTypeSwitchControl = new MapTypeSwitchControl().addTo(map);
        }
    }

    const onChangeLayers = async () => {
        if(!map)
            return

        try {
            await loadReferenceLayers()
            let time = 0;

            const _interval = setInterval(() => {
                time++;
                if(document.getElementById('layer-load-info'))
                    document.getElementById('layer-load-info').innerText = `Please wait, Layer is loading... (${time} sec)`
            }, 1000)

            loadProjectLayers().then(x => {
                clearInterval(_interval)
            })

            if(window.bounding) {
                map.removeLayer(window.bounding)
            }

            if(mapContext[type]?.bounding?.showBounding)
            {
                window.bounding = L.polygon(await ShapeFileHelper.getBounding(riverBoundingCoords, mapContext[type]?.bounding), { color: 'gray' }).addTo(map);

            }
        }
        catch (exp) {
            console.log(exp)
        }
    }

    const onLayerSearch = (item) => {
        if(item.type === 'cross_section') {
            dispatchProject({
                type: AppActions.SET_SELECTED_RS,
                data: {rs: item._text}
            })
        }
    }

    const loadToolbar = () => {
        // Skip toolbar in side-by-side mode
        if (isSideBySide) return
        
        dispatchProject({
            type: AppActions.SET_MESSAGE_TOOLBAR_ITEM,
            data: {
                toolbar: (
                    <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                        <TileSelect value={tile} onChange={setTile} tiles={getTiles()}/>
                        <ProfileSelect profiles={mapData?.profiles} onChangeProfile={setProfile} selectedProfile={profile} />
                        <Space.Compact size={'small'}>
                            <LayerSearch onChange={onLayerSearch} type={type}/>
                        </Space.Compact>
                    </div>
                )
            }
        })
    }

    const loadReferenceLayers = async () => {
        // Recursive bringToBack helper
        const bringLayerToBack = (layer) => {
            if(layer.eachLayer) {
                layer.eachLayer(bringLayerToBack);
            }
            if(layer.bringToBack) {
                layer.bringToBack();
            }
        };

        // Recreate the custom reference panes on THIS map up front. After a tab
        // switch the MapView remounts with a fresh Leaflet map, but the cached
        // reference layerObjects (kept in app context) still carry a custom
        // `options.pane` (femaPane/frisPane/neaPane). If that pane doesn't exist
        // on the new map, re-adding the cached layer has nowhere to render and it
        // stays invisible until the user toggles it off/on. Ensuring the panes
        // exist here lets cached layers re-attach and show immediately.
        const ensurePane = (name, zIndex) => {
            if (!map.getPane(name)) {
                map.createPane(name);
                map.getPane(name).style.zIndex = zIndex;
            }
        };
        ensurePane('femaPane', 350);
        ensurePane('frisPane', 351);
        ensurePane('neaPane', 352);

        const _refLayers = mapContext[type].referenceLayers.filter(x => {
            const layer = mapContext[type].selectedLayers.reference.find(y => y.name === x.name)
            if(!layer && x?.layerObject?.remove) {
                x.layerObject.remove()
                return false
            }
            else {
                if(!map.hasLayer(x.layerObject)) {
                    map.addLayer(x.layerObject)
                    // Reference layer'ı en alta gönder (recursive)
                    bringLayerToBack(x.layerObject);
                }
            }

            return true
        })

        for (const x of mapContext[type].selectedLayers.reference) {
            const layer = mapContext[type].referenceLayers.find(y => y.name === x.name)
            if(!layer) {
                try {
                    let track;

                    // Handle ArcGIS Feature Service (Vector/GeoJSON) - loads ONCE with bounding box
                    if (x.type === 'arcgis-feature') {
                        // Get bounding box from Bounding Settings (same as Show/Hide Bounding)
                        let bbox = null;
                        try {
                            const boundingCoords = await ShapeFileHelper.getBounding(riverBoundingCoords, mapContext[type]?.bounding);
                            console.log('FEMA Vector - Bounding coords:', boundingCoords);
                            if (boundingCoords && boundingCoords.length >= 4) {
                                // boundingCoords format: [[lat1,lng1], [lat2,lng2], [lat3,lng3], [lat4,lng4]]
                                const lats = boundingCoords.map(c => c[0]);
                                const lngs = boundingCoords.map(c => c[1]);
                                const minLat = Math.min(...lats);
                                const maxLat = Math.max(...lats);
                                const minLng = Math.min(...lngs);
                                const maxLng = Math.max(...lngs);
                                bbox = `${minLng},${minLat},${maxLng},${maxLat}`;
                                console.log('FEMA Vector - Using bbox:', bbox);
                            }
                        } catch (e) {
                            console.warn('Could not get bounding from settings:', e);
                        }
                        
                        // If no bounding available, don't load - show error
                        if (!bbox) {
                            notification.error({
                                message: 'Cannot load FEMA data',
                                description: 'No bounding box available. Please load a project first.'
                            });
                            track = L.layerGroup();
                            continue;
                        }
                        
                        // Split bounding box into smaller grid cells to avoid API limits
                        const [bboxXmin, bboxYmin, bboxXmax, bboxYmax] = bbox.split(',').map(c => parseFloat(c));
                        
                        // Max cell size in degrees (approx 0.05 deg = ~5km)
                        const MAX_CELL_SIZE = 0.05;
                        
                        // Calculate grid dimensions
                        const width = bboxXmax - bboxXmin;
                        const height = bboxYmax - bboxYmin;
                        const numCols = Math.ceil(width / MAX_CELL_SIZE);
                        const numRows = Math.ceil(height / MAX_CELL_SIZE);
                        const cellWidth = width / numCols;
                        const cellHeight = height / numRows;
                        
                        const totalCells = numCols * numRows;
                        console.log(`FEMA: Splitting bbox into ${numCols}x${numRows} = ${totalCells} cells`);
                        
                        // Show modal once with initial state
                        setFemaProgress({ current: 0, total: totalCells, numCols, numRows, features: 0, errors: 0 });
                        
                        // Helper: Convert ESRI JSON to GeoJSON
                        const esriToGeoJSON = (esriData) => {
                            if (!esriData.features) return { type: 'FeatureCollection', features: [] };
                            
                            const features = esriData.features.map(f => {
                                let geometry = null;
                                if (f.geometry) {
                                    if (f.geometry.rings) {
                                        geometry = { type: 'Polygon', coordinates: f.geometry.rings };
                                    } else if (f.geometry.paths) {
                                        geometry = { type: 'LineString', coordinates: f.geometry.paths[0] };
                                    } else if (f.geometry.x !== undefined) {
                                        geometry = { type: 'Point', coordinates: [f.geometry.x, f.geometry.y] };
                                    }
                                }
                                return {
                                    type: 'Feature',
                                    geometry: geometry,
                                    properties: f.attributes || {}
                                };
                            });
                            
                            return { type: 'FeatureCollection', features };
                        };

                        // FEMA encodes "no value / not applicable" as -9999 (e.g. STATIC_BFE
                        // is -9999 for Zone A / X where no Base Flood Elevation is determined).
                        // Strip those sentinels so they don't surface as "BFE: -9999 ft".
                        const FEMA_NODATA = new Set([-9999, -9998, -8888]);
                        const sanitizeFemaProps = (props) => {
                            if (!props) return props;
                            Object.keys(props).forEach(k => {
                                const v = props[k];
                                const n = typeof v === 'string' ? Number(v) : v;
                                if (typeof n === 'number' && FEMA_NODATA.has(n)) {
                                    delete props[k];
                                }
                            });
                            return props;
                        };

                        // FIRM-style NFHL palette (matches the requested legend).
                        const FEMA = {
                            ve:        '#1C7C3C', // Zone VE - dark green
                            cyan:      '#33E0E0', // Zones A, AH, AO, A99, V
                            ae:        '#1F6FE6', // Zones AE / 1% Annual Chance
                            yellow:    '#F2F20D', // 0.2% Annual Chance
                            d:         '#E3D9A6', // Zone D
                            openwater: '#1F6FE6', // Open Water
                            hatchFloodway: 'url(#fema-hatch-floodway)',
                            hatchEncroach: 'url(#fema-hatch-encroach)',
                            hatchFuture:   'url(#fema-hatch-future)',
                            hatchLevee:    'url(#fema-hatch-levee)',
                        };

                        // Inject the SVG <pattern> defs once (shared by id across the doc).
                        const ensureFemaSvgPatterns = () => {
                            if (document.getElementById('fema-svg-defs')) return;
                            const NS = 'http://www.w3.org/2000/svg';
                            const svg = document.createElementNS(NS, 'svg');
                            svg.setAttribute('id', 'fema-svg-defs');
                            svg.setAttribute('width', '0');
                            svg.setAttribute('height', '0');
                            svg.style.position = 'absolute';
                            const defs = document.createElementNS(NS, 'defs');
                            const mkHatch = (id, color, angle, strokeW) => {
                                const p = document.createElementNS(NS, 'pattern');
                                p.setAttribute('id', id);
                                p.setAttribute('patternUnits', 'userSpaceOnUse');
                                p.setAttribute('width', '8');
                                p.setAttribute('height', '8');
                                p.setAttribute('patternTransform', `rotate(${angle})`);
                                const line = document.createElementNS(NS, 'line');
                                line.setAttribute('x1', '0'); line.setAttribute('y1', '0');
                                line.setAttribute('x2', '0'); line.setAttribute('y2', '8');
                                line.setAttribute('stroke', color);
                                line.setAttribute('stroke-width', String(strokeW));
                                p.appendChild(line);
                                defs.appendChild(p);
                            };
                            mkHatch('fema-hatch-floodway', FEMA.ae, 45, 3);   // blue diagonal
                            mkHatch('fema-hatch-encroach', FEMA.ae, 135, 3);  // blue, opp. angle
                            mkHatch('fema-hatch-future', '#333333', 45, 3);   // dark diagonal
                            mkHatch('fema-hatch-levee', '#F08A1E', 45, 3);    // orange diagonal
                            svg.appendChild(defs);
                            document.body.appendChild(svg);
                        };

                        // Classify a flood-zone feature into the requested FIRM-style legend
                        // class (keyed on FLD_ZONE + ZONE_SUBTY, like FEMA's renderer).
                        // Returns null for classes that are not drawn (Zone X / minimal /
                        // area not included) so they are excluded entirely.
                        // `z` is the stacking priority (higher = drawn on top).
                        const classifyFemaZone = (zoneRaw, subtypeRaw) => {
                            const zone = (zoneRaw || '').toString().toUpperCase().trim();
                            const sub = (subtypeRaw || '').toString().toUpperCase().trim().replace(/<NULL>/g, '');

                            if (sub.includes('AREA OF MINIMAL FLOOD HAZARD')) return null; // Zone X
                            if (zone === 'AREA NOT INCLUDED') return null;

                            const isFuture = sub.includes('FUTURE COND'); // incl. typo "CONDITONS"
                            const isEncroach = sub.includes('COMMUNITY ENCROACHMENT') ||
                                               sub.includes('STATE ENCROACHMENT');
                            const isFloodway = sub.includes('FLOODWAY') ||
                                               sub.includes('FLOWAGE EASEMENT AREA') ||
                                               sub.includes('AREA OF SPECIAL CONSIDERATION') ||
                                               sub.includes('COLORADO RIVER') ||
                                               sub.includes('DENSITY FRINGE AREA');
                            const isLevee = sub.includes('PROTECTED BY LEVEE') ||
                                            sub.includes('REDUCED FLOOD RISK DUE TO LEVEE') ||
                                            sub.includes('REDUCED FLOOD HAZARD DUE TO ACCREDITED LEVEE') ||
                                            sub.includes('REDUCED FLOOD HAZARD DUE TO PROVISIONALLY ACCREDITED LEVEE');

                            if (zone === 'OPEN WATER') {
                                return { label: 'Open Water', fill: FEMA.openwater, hatch: false, z: 1 };
                            }

                            if (zone === 'X') {
                                if (isFuture && isEncroach) {
                                    return { label: '1% Future Conditions: Community Encroachment Area', fill: FEMA.hatchEncroach, hatch: true, z: 3 };
                                }
                                if (isFuture) {
                                    return { label: 'Zone X: 1% Future Conditions', fill: FEMA.hatchFuture, hatch: true, z: 3 };
                                }
                                if (isLevee) {
                                    return { label: 'Zone X: Protected By Levee', fill: FEMA.hatchLevee, hatch: true, z: 3 };
                                }
                                if (sub.includes('0.2 PCT') || sub.includes('0.2 PERCENT') ||
                                    sub.includes('DEPTH LESS THAN 1 FOOT') ||
                                    sub.includes('DRAINAGE AREA LESS THAN 1 SQUARE MILE') ||
                                    sub.includes('FLOOD HAZARD DUE TO NON-ACCREDITED LEVEE')) {
                                    return { label: '0.2% Annual Chance Flood Hazard', fill: FEMA.yellow, hatch: false, z: 3 };
                                }
                                return null; // plain / unshaded Zone X
                            }

                            if (zone === 'D') {
                                return { label: 'Zone D', fill: FEMA.d, hatch: false, z: 2 };
                            }

                            // 1% Annual Chance family
                            if (['A', 'AE', 'AH', 'AO', 'AR', 'A99', 'V', 'VE'].includes(zone)) {
                                if (isFloodway && !isFuture) {
                                    return { label: 'Floodway', fill: FEMA.hatchFloodway, hatch: true, z: 5 };
                                }
                                if (isEncroach && !isFuture) {
                                    return { label: 'Community Encroachment Area', fill: FEMA.hatchEncroach, hatch: true, z: 5 };
                                }
                                if (zone === 'VE') {
                                    return { label: 'Zone VE', fill: FEMA.ve, hatch: false, z: 4 };
                                }
                                if (zone === 'AE') {
                                    return { label: 'Zone AE (1% Annual Chance)', fill: FEMA.ae, hatch: false, z: 4 };
                                }
                                return { label: 'Zones A, AH, AO, A99, V', fill: FEMA.cyan, hatch: false, z: 4 };
                            }

                            return null;
                        };
                        
                        // Build grid cells and fetch each
                        const allFeatures = [];
                        const featureIds = new Set(); // To avoid duplicates
                        let successCount = 0;
                        let errorCount = 0;
                        
                        try {
                            let cellIndex = 0;
                            for (let row = 0; row < numRows; row++) {
                                for (let col = 0; col < numCols; col++) {
                                    cellIndex++;
                                    const cellXmin = (bboxXmin + col * cellWidth).toFixed(4);
                                    const cellYmin = (bboxYmin + row * cellHeight).toFixed(4);
                                    const cellXmax = (bboxXmin + (col + 1) * cellWidth).toFixed(4);
                                    const cellYmax = (bboxYmin + (row + 1) * cellHeight).toFixed(4);
                                    
                                    const baseQueryUrl = `${x.url}/query?where=1%3D1&geometryType=esriGeometryEnvelope&geometry=${cellXmin}%2C${cellYmin}%2C${cellXmax}%2C${cellYmax}&inSR=4326&outSR=4326&spatialRel=esriSpatialRelIntersects&outFields=${encodeURIComponent(x.options?.outFields || '*')}&returnGeometry=true&f=json`;

                                    try {
                                        // The FEMA NFHL service caps each response at maxRecordCount
                                        // (2000 for layer 28). A single grid cell can contain more
                                        // flood-zone polygons than that, so we must page through
                                        // the results with resultOffset until exceededTransferLimit
                                        // is no longer set - otherwise zones such as the 0.2% PCT
                                        // (500-yr) polygon get silently dropped when truncated.
                                        let cellHadError = false;
                                        let resultOffset = 0;
                                        const PAGE_SIZE = 2000;
                                        let exceededTransferLimit = false;

                                        do {
                                            const queryUrl = `${baseQueryUrl}&resultOffset=${resultOffset}&resultRecordCount=${PAGE_SIZE}`;
                                            const response = await fetch(queryUrl);
                                            const esriData = await response.json();

                                            if (esriData.error) {
                                                console.warn(`FEMA cell [${row},${col}] error:`, esriData.error?.message);
                                                cellHadError = true;
                                                break;
                                            }

                                            // ArcGIS reports the real OBJECTID field name; fall back
                                            // to "OBJECTID". This makes de-duplication reliable -
                                            // the previous code keyed on the first ring vertex, and
                                            // because coincident FEMA zones (e.g. 1% AE and the
                                            // shaded-X 0.2% PCT) share boundary vertices, the 0.2%
                                            // polygon was being discarded as a false duplicate.
                                            const oidField = esriData.objectIdFieldName || 'OBJECTID';
                                            const pageFeatures = esriData.features || [];

                                            if (pageFeatures.length > 0) {
                                                const geojson = esriToGeoJSON(esriData);
                                                geojson.features.forEach((f, i) => {
                                                    const oid = pageFeatures[i]?.attributes?.[oidField];
                                                    const fid = (oid !== undefined && oid !== null)
                                                        ? `oid:${oid}`
                                                        : `geom:${JSON.stringify(f.geometry?.coordinates)}`;
                                                    if (!featureIds.has(fid)) {
                                                        featureIds.add(fid);
                                                        sanitizeFemaProps(f.properties);
                                                        allFeatures.push(f);
                                                    }
                                                });
                                            }

                                            exceededTransferLimit = esriData.exceededTransferLimit === true;
                                            resultOffset += pageFeatures.length;

                                            // Guard against an unmoving offset (no progress)
                                            if (pageFeatures.length === 0) {
                                                exceededTransferLimit = false;
                                            }
                                        } while (exceededTransferLimit);

                                        if (cellHadError) {
                                            errorCount++;
                                        } else {
                                            // A cell with no features is still a successful query
                                            successCount++;
                                        }
                                    } catch (cellError) {
                                        console.warn(`FEMA cell [${row},${col}] fetch error:`, cellError);
                                        errorCount++;
                                    }
                                    
                                    // Update progress after each cell
                                    setFemaProgress(prev => ({
                                        ...prev,
                                        current: cellIndex,
                                        features: allFeatures.length,
                                        errors: errorCount
                                    }));
                                }
                            }
                            
                            console.log(`FEMA: Loaded ${allFeatures.length} unique features from ${successCount} cells (${errorCount} errors)`);
                            
                            if (allFeatures.length > 0) {
                                // FEMA flood zones are nested polygons (e.g. a FLOODWAY
                                // polygon sits inside the broader AE 1% polygon). They all
                                // render in the same SVG, so the broader zone drawn last
                                // would hide the narrower/more-severe one. Sort so the most
                                // severe zones are drawn on top (Floodway always visible).
                                const renderOrder = (feature) => {
                                    const cls = classifyFemaZone(feature.properties?.FLD_ZONE, feature.properties?.ZONE_SUBTY);
                                    return cls ? (cls.z || 0) : 0;
                                };
                                allFeatures.sort((a, b) => renderOrder(a) - renderOrder(b));

                                ensureFemaSvgPatterns();

                                const geojsonData = { type: 'FeatureCollection', features: allFeatures };
                                const fillOpacity = x.options?.style?.fillOpacity ?? 0.5;

                                // Render FEMA in its own pane below the project layers.
                                // Default panes: tilePane=200, overlayPane=400 (project
                                // vectors + result rasters live here). zIndex 350 keeps
                                // FEMA above the basemap but always under project layers,
                                // which bringToBack() alone can't guarantee across panes.
                                if (!map.getPane('femaPane')) {
                                    map.createPane('femaPane');
                                    map.getPane('femaPane').style.zIndex = 350;
                                }

                                track = L.geoJSON(geojsonData, {
                                    pane: 'femaPane',
                                    // Only keep polygons FEMA actually renders. This drops
                                    // "Area of Minimal Flood Hazard" and plain unshaded X
                                    // entirely (not even clickable), matching the NFHL legend.
                                    filter: (feature) => {
                                        return classifyFemaZone(
                                            feature.properties?.FLD_ZONE,
                                            feature.properties?.ZONE_SUBTY
                                        ) !== null;
                                    },
                                    style: (feature) => {
                                        const cls = classifyFemaZone(
                                            feature.properties?.FLD_ZONE,
                                            feature.properties?.ZONE_SUBTY
                                        );
                                        // filter() already excluded null classes; guard anyway.
                                        if (!cls) {
                                            return { stroke: false, weight: 0, fill: false, fillOpacity: 0 };
                                        }
                                        // Hatched classes use an SVG <pattern> as the fill;
                                        // keep them near-opaque so the stripes read clearly.
                                        return {
                                            stroke: false,
                                            weight: 0,
                                            fill: true,
                                            fillColor: cls.fill,
                                            fillOpacity: cls.hatch ? 0.95 : fillOpacity
                                        };
                                    },
                                    onEachFeature: (feature, layer) => {
                                        layer.on('mouseover', function(e) {
                                            const props = feature.properties || {};
                                            const zone = props.FLD_ZONE || 'N/A';
                                            const subtype = (props.ZONE_SUBTY || '').replace(/<Null>/gi, '').trim();
                                            // STATIC_BFE is undefined here when it was FEMA's
                                            // -9999 no-data sentinel (already stripped on load).
                                            const bfe = (props.STATIC_BFE != null) ? `BFE: ${props.STATIC_BFE} ft` : '';
                                            const tooltip = `Zone: ${zone} ${subtype}\n${bfe}`.trim();
                                            layer.bindTooltip(tooltip, {sticky: true}).openTooltip();
                                        });
                                        
                                        layer.on('click', function(e) {
                                            L.DomEvent.stopPropagation(e);
                                            createLeafletPopup({
                                                L,
                                                content: (<ShapeItem feature={feature} />),
                                                contentStyle: { maxHeight: 380, overflowY: 'auto' },
                                                properties: {autoPan: true},
                                                latlng: e.latlng,
                                                map
                                            });
                                        });
                                    }
                                });
                                
                                notification.success({
                                    message: `FEMA NFHL loaded`,
                                    description: `${allFeatures.length} flood zone features from ${numCols * numRows} grid cells`
                                });
                                setFemaProgress(null);
                            } else {
                                notification.warning({
                                    message: 'No FEMA data',
                                    description: 'No flood zones found in this area'
                                });
                                track = L.layerGroup();
                                setFemaProgress(null);
                            }
                        } catch (fetchError) {
                            console.error('FEMA Feature Service error:', fetchError);
                            notification.error({
                                message: 'FEMA load failed',
                                description: 'Could not load flood zone data'
                            });
                            track = L.layerGroup();
                            setFemaProgress(null);
                        }
                    }
                    // Handle WMS layers (unbounded - full map)
                    else if (x.type === 'wms') {
                        openModal({
                            title: 'Layer is loading...',
                            component: (<Spin spinning={true} />),
                            closable: false
                        });
                        track = L.tileLayer.wms(x.url, {
                            layers: x.layers,
                            format: x.options?.format || 'image/png',
                            transparent: x.options?.transparent !== false,
                            version: x.options?.version || '1.1.1',
                            attribution: x.options?.attribution || '',
                            opacity: 0.7
                        });
                    }
                    // Handle WMS layers with bounding box limit
                    else if (x.type === 'wms-bounded') {
                        openModal({
                            title: 'Layer is loading...',
                            component: (<Spin spinning={true} />),
                            closable: false
                        });
                        // Get bounding box from Bounding Settings
                        let wmsBounds = null;
                        try {
                            const boundingCoords = await ShapeFileHelper.getBounding(riverBoundingCoords, mapContext[type]?.bounding);
                            if (boundingCoords && boundingCoords.length >= 4) {
                                const lats = boundingCoords.map(c => c[0]);
                                const lngs = boundingCoords.map(c => c[1]);
                                const minLat = Math.min(...lats);
                                const maxLat = Math.max(...lats);
                                const minLng = Math.min(...lngs);
                                const maxLng = Math.max(...lngs);
                                wmsBounds = L.latLngBounds(
                                    L.latLng(minLat, minLng),
                                    L.latLng(maxLat, maxLng)
                                );
                            }
                        } catch (e) {
                            console.warn('Could not get bounding for WMS:', e);
                        }
                        
                        if (!wmsBounds) {
                            notification.error({
                                message: 'Cannot load FEMA layer',
                                description: 'No bounding box available. Please load a project first.'
                            });
                            track = L.layerGroup();
                        } else if (x.options?.isArcGIS) {
                            // ArcGIS REST Export - create image overlay
                            const sw = wmsBounds.getSouthWest();
                            const ne = wmsBounds.getNorthEast();
                            const bboxStr = `${sw.lng},${sw.lat},${ne.lng},${ne.lat}`;
                            
                            // Calculate image size based on bounds (reasonable size)
                            const aspectRatio = (ne.lng - sw.lng) / (ne.lat - sw.lat);
                            const height = 1024;
                            const width = Math.round(height * aspectRatio);
                            
                            // Use base URL from config, append export parameters
                            // Use layerDefs to show only flood zones, dpi=96 for better quality
                            const baseUrl = x.url.replace(/\/export\/?$/, '');
                            const exportUrl = `${baseUrl}/export?bbox=${bboxStr}&bboxSR=4326&imageSR=3857&layers=show:${x.layers}&layerDefs=&size=${width},${height}&format=${x.options?.format || 'png32'}&transparent=true&dpi=96&f=image`;
                            
                            console.log('ArcGIS Export URL:', exportUrl);
                            
                            track = L.imageOverlay(exportUrl, wmsBounds, {
                                opacity: 0.7,
                                attribution: x.options?.attribution || ''
                            });
                            
                            // Handle load errors
                            track.on('error', (error) => {
                                console.error('ArcGIS Export Error:', error);
                                notification.error({
                                    message: 'FEMA layer load failed',
                                    description: 'Could not load flood zone image'
                                });
                            });
                        } else {
                            // Standard WMS
                            const wmsOptions = {
                                layers: x.layers,
                                format: x.options?.format || 'image/png',
                                transparent: x.options?.transparent !== false,
                                version: x.options?.version || '1.1.1',
                                attribution: x.options?.attribution || '',
                                opacity: 0.7,
                                bounds: wmsBounds
                            };
                            // Add CRS if specified (convert string to L.CRS)
                            if (x.options?.crs) {
                                const crsMap = {
                                    'EPSG4326': L.CRS.EPSG4326,
                                    'EPSG3857': L.CRS.EPSG3857,
                                    'EPSG3395': L.CRS.EPSG3395
                                };
                                wmsOptions.crs = crsMap[x.options.crs] || L.CRS.EPSG3857;
                            }
                            console.log('WMS Options:', wmsOptions, 'URL:', x.url);
                            track = L.tileLayer.wms(x.url, wmsOptions);
                            
                            // Add error handler
                            track.on('tileerror', (error) => {
                                console.error('WMS Tile Error:', error);
                            });
                        }
                    }
                    // Server-rendered ArcGIS dynamic map (the /export op, EPSG:3857),
                    // drawn with the SERVICE'S OWN symbology (e.g. NC FRIS Flood
                    // Zones). Loaded ONCE for the project's bounding box as a single
                    // static image overlay — NOT zoom-driven tiles — so it never
                    // re-fetches while the user zooms/pans; it just scales. Export
                    // resolution is capped at the service's max size for the sharpest
                    // single still ("en yakın hali"). A click still runs identify.
                    else if (x.type === 'arcgis-dynamic') {
                        if (!map.getPane('frisPane')) {
                            map.createPane('frisPane');
                            map.getPane('frisPane').style.zIndex = 351;
                        }
                        const baseUrl = x.url.replace(/\/+$/, '');
                        const showLayers = x.options?.layers != null ? `&layers=show:${x.options.layers}` : '';

                        const bcoords = await ShapeFileHelper.getBounding(riverBoundingCoords, mapContext[type]?.bounding);
                        if (bcoords && bcoords.length >= 4) {
                            const lats = bcoords.map(c => c[0]);
                            const lngs = bcoords.map(c => c[1]);
                            const south = Math.min(...lats), north = Math.max(...lats);
                            const west = Math.min(...lngs), east = Math.max(...lngs);
                            const swM = L.CRS.EPSG3857.project(L.latLng(south, west));
                            const neM = L.CRS.EPSG3857.project(L.latLng(north, east));
                            const wM = Math.abs(neM.x - swM.x), hM = Math.abs(neM.y - swM.y);
                            const MAX = x.options?.maxExportSize ?? 4096; // service maxImageWidth/Height
                            let w = MAX, h = MAX;
                            if (wM >= hM) { h = Math.max(1, Math.round(MAX * (hM / wM))); }
                            else { w = Math.max(1, Math.round(MAX * (wM / hM))); }
                            const exportUrl = `${baseUrl}/export?bbox=${swM.x},${swM.y},${neM.x},${neM.y}`
                                + `&bboxSR=3857&imageSR=3857&size=${w},${h}&dpi=96`
                                + `&format=png32&transparent=true${showLayers}&f=image`;
                            track = L.imageOverlay(exportUrl, [[south, west], [north, east]], {
                                pane: 'frisPane',
                                opacity: x.options?.opacity ?? 0.7,
                                attribution: x.options?.attribution || '',
                            });
                        } else {
                            track = L.layerGroup(); // no project bbox available
                        }

                        if (x.options?.identify && track && track.on) {
                            const onIdentify = async (e) => {
                                try {
                                    // Use the map that fired the click (not a captured
                                    // reference), so identify keeps working after the
                                    // MapView remounts and the layer re-attaches.
                                    const m = e.target;
                                    const b = m.getBounds();
                                    const sz = m.getSize();
                                    const params = new URLSearchParams({
                                        f: 'json',
                                        geometry: `${e.latlng.lng},${e.latlng.lat}`,
                                        geometryType: 'esriGeometryPoint',
                                        sr: '4326',
                                        tolerance: '4',
                                        returnGeometry: 'false',
                                        layers: 'visible',
                                        mapExtent: `${b.getWest()},${b.getSouth()},${b.getEast()},${b.getNorth()}`,
                                        imageDisplay: `${sz.x},${sz.y},96`,
                                    });
                                    const res = await fetch(`${baseUrl}/identify?${params.toString()}`);
                                    const data = await res.json();
                                    const hit = (data?.results || [])[0];
                                    if (!hit) return;
                                    const a = hit.attributes || {};
                                    // -9999 / null / empty = "no value" in the FRIS schema.
                                    const num = (v) => (v != null && `${v}` !== '-9999' && `${v}` !== '' && !Number.isNaN(Number(v))) ? Number(v) : null;
                                    const zone = a['ZONE_LID_VALUE'] || a['ZONE_LID'] || a['FLD_ZONE'] || hit.value || '';
                                    const sub = a['ZONESUB_LID_VALUE'] || a['ZONE_SUBTY'] || '';
                                    const bfe = num(a['STATIC_BFE']);
                                    const depth = num(a['DEPTH']);
                                    const vel = num(a['VELOCITY']);
                                    const sfha = a['SFHA_TF'];
                                    const rows = [
                                        ['Flood Zone', zone || '—'],
                                        sub ? ['Subtype', sub] : null,
                                        bfe != null ? ['Base Flood Elevation', `${bfe} ft`] : null,
                                        depth != null ? ['Depth', `${depth} ft`] : null,
                                        vel != null ? ['Velocity', `${vel} ft/s`] : null,
                                        (sfha === 0 || sfha === 1) ? ['Special Flood Hazard Area', sfha === 1 ? 'Yes' : 'No'] : null,
                                    ].filter(Boolean);
                                    const html = `<div style="font:12px 'Segoe UI',sans-serif;min-width:180px">`
                                        + `<div style="font-weight:600;margin-bottom:4px;border-bottom:1px solid #e0e0e0;padding-bottom:3px">${hit.layerName || 'FRIS Flood Zone'}</div>`
                                        + `<table style="border-collapse:collapse">`
                                        + rows.map(([k, v]) => `<tr><td style="color:#666;padding:1px 8px 1px 0;vertical-align:top">${k}</td><td style="font-weight:600">${v}</td></tr>`).join('')
                                        + `</table></div>`;
                                    L.popup({maxWidth: 320}).setLatLng(e.latlng).setContent(html).openOn(m);
                                } catch (err) { /* identify failed — ignore */ }
                            };
                            // Bind the click on whichever map the layer is currently
                            // added to, and unbind from that same map on remove — so a
                            // remount (new map) re-wires correctly instead of leaving
                            // the handler on the destroyed map.
                            let boundMap = null;
                            track.on('add', (ev) => {
                                boundMap = ev.target?._map || null;
                                if (boundMap) boundMap.on('click', onIdentify);
                            });
                            track.on('remove', () => {
                                if (boundMap) { boundMap.off('click', onIdentify); boundMap = null; }
                            });
                        }
                    }
                    // ArcGIS vector tiles (.pbf) for a layer published ONLY as a
                    // VectorTileServer (e.g. NC FRIS "Non-Encroachment Areas" /
                    // Effective_NEAs — no /export op). Loaded ONCE for the project
                    // bounding box: the tiles covering the bbox at a single zoom are
                    // fetched, decoded client-side (pbf + @mapbox/vector-tile) and
                    // merged into one static GeoJSON overlay that scales with zoom
                    // and never re-fetches. The tiles are public + CORS-enabled on
                    // tiles.arcgis.com, so no proxy is needed. NOTE: ArcGIS tile
                    // addressing is /tile/{z}/{y}/{x}.pbf — y (row) before x (col).
                    else if (x.type === 'arcgis-vectortile') {
                        if (!map.getPane('neaPane')) {
                            map.createPane('neaPane');
                            map.getPane('neaPane').style.zIndex = 352; // above frisPane (351)
                        }
                        // Group-opacity the whole pane instead of per-feature
                        // fillOpacity: tiles are decoded independently and their
                        // clipped pieces overlap along seams (vector-tile buffer),
                        // so semi-transparent fills would STACK into darker bands.
                        // Drawing fills opaque (fillOpacity: 1 below) and fading the
                        // entire pane ONCE flattens those overlaps to one uniform tone.
                        map.getPane('neaPane').style.opacity = String(x.options?.fillOpacity ?? 0.30);
                        const tplBase = x.url.replace(/\/+$/, '');
                        const sourceLayers = x.options?.sourceLayers || ['Non Encroachment Area'];
                        const fc = { type: 'FeatureCollection', features: [] };

                        const bcoords = await ShapeFileHelper.getBounding(riverBoundingCoords, mapContext[type]?.bounding);
                        if (bcoords && bcoords.length >= 4) {
                            const lats = bcoords.map(c => c[0]);
                            const lngs = bcoords.map(c => c[1]);
                            const south = Math.min(...lats), north = Math.max(...lats);
                            const west = Math.min(...lngs), east = Math.max(...lngs);

                            const lngToX = (lng, z) => Math.floor((lng + 180) / 360 * Math.pow(2, z));
                            const latToY = (lat, z) => {
                                const r = lat * Math.PI / 180;
                                return Math.floor((1 - Math.log(Math.tan(r) + 1 / Math.cos(r)) / Math.PI) / 2 * Math.pow(2, z));
                            };

                            // Highest zoom (≤ service max LOD) that keeps the bbox
                            // within a small tile budget — best detail, few requests.
                            const maxZ = x.options?.maxNativeZoom ?? 19;
                            const TILE_BUDGET = x.options?.tileBudget ?? 16;
                            let z = maxZ;
                            for (; z >= 8; z--) {
                                const xc = lngToX(east, z) - lngToX(west, z) + 1;
                                const yc = latToY(south, z) - latToY(north, z) + 1;
                                if (xc * yc <= TILE_BUDGET) break;
                            }
                            const xMin = lngToX(west, z), xMax = lngToX(east, z);
                            const yMin = latToY(north, z), yMax = latToY(south, z);

                            const reqs = [];
                            for (let tx = xMin; tx <= xMax; tx++) {
                                for (let ty = yMin; ty <= yMax; ty++) {
                                    const url = `${tplBase}/tile/${z}/${ty}/${tx}.pbf`;
                                    reqs.push(
                                        fetch(url)
                                            .then(r => (r.ok ? r.arrayBuffer() : null))
                                            .then(buf => {
                                                if (!buf || buf.byteLength === 0) return;
                                                const vt = new VectorTile(new PbfReader(new Uint8Array(buf)));
                                                sourceLayers.forEach(sl => {
                                                    const layer = vt.layers[sl];
                                                    if (!layer) return;
                                                    for (let i = 0; i < layer.length; i++) {
                                                        const gj = layer.feature(i).toGeoJSON(tx, ty, z);
                                                        if (gj) fc.features.push(gj);
                                                    }
                                                });
                                            })
                                            .catch(() => { /* skip unreachable/garbled tile */ })
                                    );
                                }
                            }
                            await Promise.all(reqs);
                        }

                        track = L.geoJSON(fc, {
                            pane: 'neaPane',
                            interactive: false,
                            style: {
                                fill: true,
                                fillColor: x.options?.fillColor || '#e60000',
                                fillOpacity: 1, // opaque; pane opacity (above) supplies the overall transparency
                                color: x.options?.color || '#b30000',
                                weight: x.options?.weight ?? 1,
                            },
                        });
                    }
                    // Handle admin-managed reference layers (FlatGeobuf via geo API).
                    // The server runs a bbox query against the layer's embedded
                    // spatial index and returns only features that intersect the
                    // current bounding box, so even very large layers (40 MB+)
                    // stay responsive.
                    else if (x.slug) {
                        openModal({
                            title: 'Layer is loading...',
                            component: (<Spin spinning={true} />),
                            closable: false
                        });

                        // bounding coords come back as [lat, lng] pairs; the API
                        // expects [minLng, minLat, maxLng, maxLat].
                        let bbox = null
                        try {
                            const coords = await ShapeFileHelper.getBounding(riverBoundingCoords, mapContext[type]?.bounding);
                            if (coords && coords.length >= 4) {
                                const lats = coords.map(c => c[0])
                                const lngs = coords.map(c => c[1])
                                bbox = [Math.min(...lngs), Math.min(...lats), Math.max(...lngs), Math.max(...lats)]
                            }
                        } catch (e) {
                            console.warn('No bbox available for layer', x.slug, e)
                        }

                        const geojson = await ApiService.Layers.Query(x.slug, bbox ? {bbox} : {})
                        if (!geojson) {
                            track = L.layerGroup()
                        } else {
                            track = L.geoJSON(geojson, {
                                style: {
                                    color: '#0066ff',
                                    fillColor: '#3399ff',
                                    fillOpacity: 0.3,
                                    weight: 2,
                                },
                                onEachFeature: (feature, layer) => {
                                    if (!feature?.properties) return;
                                    layer.on('mouseover', function() {
                                        // Bilinen slug'lar icin ozel etiket (or. "PANEL ID: 0760",
                                        // "County: McDowell"); digerlerinde ilk dolu property.
                                        const label = getLayerHoverLabel(x.slug, feature);
                                        let html;
                                        if (label != null) {
                                            html = ReactDOMServer.renderToString(
                                                <div style={{fontWeight: 'bold', whiteSpace: 'nowrap'}}>{label}</div>
                                            );
                                        } else {
                                            const key = Object.keys(feature.properties).find(k => feature.properties[k]);
                                            if (!key) return;
                                            html = ReactDOMServer.renderToString(
                                                <ShapeTooltip labels={[key]} feature={feature}/>
                                            );
                                        }
                                        layer.bindTooltip(L.tooltip({}).setContent(html), {sticky: true}).openTooltip();
                                    });
                                    layer.on('click', function(e) {
                                        L.DomEvent.stopPropagation(e);
                                        if (Object.keys(feature.properties).length > 0) {
                                            createLeafletPopup({
                                                L,
                                                content: (<ShapeItem feature={feature} slug={x.slug}/>),
                                                contentStyle: {maxHeight: 380, overflowY: 'auto'},
                                                properties: {autoPan: true},
                                                latlng: e.latlng,
                                                map,
                                            });
                                        }
                                    });
                                },
                            });
                        }
                    }
                    
                    _refLayers.push({
                        ...x,
                        layerObject: track
                    })
                    map.addLayer(track);
                    
                    // Reference layer'ları en alta gönder (recursive)
                    bringLayerToBack(track);
                }
                catch (exp) {
                    console.log(exp)
                }
                
                closeModal()
            }
        }

        dispatchProject({
            type: AppActions.SET_MAP_CONTEXT,
            data: {
                map: {
                    ...mapContext,
                    [type]: {
                        ...mapContext[type],
                        referenceLayers: [..._refLayers]
                    }
                }
            }
        })
    }

    function applyHillshade(georaster, row, col, zFactor = 1, azimuth = 315, altitude = 45) {
        const width = georaster.width;
        const height = georaster.height;

        // Çevre pikselleri kullanarak z değerlerini al
        const z1 = georaster.values[0][row - 1]?.[col - 1] * zFactor || 0;
        const z2 = georaster.values[0][row - 1]?.[col] * zFactor || 0;
        const z3 = georaster.values[0][row - 1]?.[col + 1] * zFactor || 0;
        const z4 = georaster.values[0][row]?.[col - 1] * zFactor || 0;
        const z5 = georaster.values[0][row]?.[col + 1] * zFactor || 0;
        const z6 = georaster.values[0][row + 1]?.[col - 1] * zFactor || 0;
        const z7 = georaster.values[0][row + 1]?.[col] * zFactor || 0;
        const z8 = georaster.values[0][row + 1]?.[col + 1] * zFactor || 0;

        // dz/dx ve dz/dy eğim hesaplaması (mutlak değer ile negatif pixelHeight sorununu çöz)
        const dzdx = ((z3 + 2 * z5 + z8) - (z1 + 2 * z4 + z6)) / (8 * Math.abs(georaster.pixelWidth));
        // pixelHeight negatif olabilir (kuzey-yukarı görüntülerde), bu yüzden işareti düzelt
        const signY = georaster.pixelHeight < 0 ? -1 : 1;
        const dzdy = signY * ((z6 + 2 * z7 + z8) - (z1 + 2 * z2 + z3)) / (8 * Math.abs(georaster.pixelHeight));

        // Eğimi ve aspect (açı) hesaplama
        const slope = Math.atan(Math.sqrt(dzdx * dzdx + dzdy * dzdy));
        const aspect = Math.atan2(dzdy, -dzdx);

        // Işık açısı ve aydınlanma hesaplaması
        const radians = (angle) => (angle * Math.PI) / 180;
        const zenith = radians(90 - altitude);
        const azimuthRad = radians(azimuth);

        // Hillshade hesaplama
        const shade = Math.cos(zenith) * Math.cos(slope) +
            Math.sin(zenith) * Math.sin(slope) * Math.cos(azimuthRad - aspect);

        return Math.max(0, Math.min(255, Math.round(255 * shade)));
    }

    function pixelValueToColor(elevationValue, minElevation, maxElevation) {
        const normalizedValue = (elevationValue - minElevation) / (maxElevation - minElevation);

        // Elevation color scale: High contrast version
        const colorScale = [
            [0, 100, 0, 255],      // Dark Green (lowest)
            [50, 205, 50, 255],    // Lime Green
            [173, 255, 47, 255],   // Green-Yellow
            [255, 255, 0, 255],    // Bright Yellow
            [255, 165, 0, 255],    // Bright Orange
            [255, 69, 0, 255],     // Orange-Red
            [255, 0, 0, 255],      // Pure Red
            [139, 0, 0, 255],      // Dark Red
            [75, 0, 30, 255],      // Very Dark Maroon (highest)
        ];

        const numColors = colorScale.length;
        const scaleStep = 1 / (numColors - 1);

        let r = 255, g = 255, b = 255;
        for (let i = 0; i < numColors - 1; i++) {
            const lowerBound = i * scaleStep;
            const upperBound = (i + 1) * scaleStep;

            if (normalizedValue >= lowerBound && normalizedValue <= upperBound) {
                const factor = (normalizedValue - lowerBound) / (upperBound - lowerBound);

                r = Math.round(colorScale[i][0] + factor * (colorScale[i + 1][0] - colorScale[i][0]));
                g = Math.round(colorScale[i][1] + factor * (colorScale[i + 1][1] - colorScale[i][1]));
                b = Math.round(colorScale[i][2] + factor * (colorScale[i + 1][2] - colorScale[i][2]));
                break;
            }
        }

        return [r, g, b];
    }

// Gölge efektini renge uygulama fonksiyonu
    function applyShadeToColor(color, shadeValue) {
        // Renk bileşenlerine hillshade uygula (gölge etkisi)
        const factor = shadeValue / 255;
        const r = Math.round(color[0] * factor);
        const g = Math.round(color[1] * factor);
        const b = Math.round(color[2] * factor);

        return [r,g,b];
    }


    const getHighlightColor = (feature, existObjectId) => {
        let color = '#ffff00';
        let highlight = false

        let key = 'OBJECTID'
        if(!existObjectId) {
            key = 'SURVPT_ID'
        }

        const props = feature?.properties || {}
        const point = highlightSurvey.find(x => x?.properties[key] === props[key])
        if(point) {
            color = 'lightblue'
            highlight = true
        }

        return {color, highlight}
    }

    const loadProjectLayers = async () => {
        if(!window.projectShapes) {
            window.projectShapes = {}
        }

        Object.keys(window.projectShapes).forEach(key => {
            if(window.projectShapes[key]?.remove){
                window.projectShapes[key].remove()
            }
        })

        // add layers
        for (const x of mapContext[type].selectedLayers.project) {
            const layerRow = projectLayers.find(y => y.id === x.id)
            if(layerRow) {
                // add
                try {
                    if(layerRow.ext?.toLowerCase() === 'geojson') {
                        const bounding = await ShapeFileHelper.getBounding(riverBoundingCoords, mapContext[type]?.bounding)
                        let layerData = {}
                        if(typeof layerRow.data === 'string') {
                            layerData = JSON.parse(layerRow.data)
                        }
                        else {
                            layerData = {...layerRow.data}
                        }

                        layerData = ShapeFileHelper.filterFeatures(layerData, layerRow.filters || {}, bounding)

                        const labelGroup = L.markerClusterGroup({
                            zoomToBoundsOnClick: true,
                            maxClusterRadius: (zoom) => {
                                return (zoom >= 25) ? 0 : 40
                            },
                            iconCreateFunction: function(cluster) {
                                const markers = cluster.getAllChildMarkers()
                                let pointColor = 'yellow';
                                for (const marker of markers) {
                                    const {color, highlight} = getHighlightColor(marker.feature, layerRow?.existObjectId)
                                    if(highlight) {
                                        pointColor = color
                                        break
                                    }
                                }

                                const count = cluster.getChildCount()
                                return L.divIcon({ html: `<div style="background-color: ${pointColor}; width: 24px; border-radius: 16px; border: 2px solid black; font-weight: bold; padding-left: 4px;">${count}</div>` });
                            }
                        });

                        labelGroup.addTo(map)
                        window.projectShapes[v4()] = labelGroup;
                        window.projectShapes[layerRow.id] = L.geoJSON(layerData, {
                            pointToLayer: function (feature, latlng) {
                                if(feature?.geometry?.type === 'Point') {
                                    const {color, highlight} = getHighlightColor(feature, layerRow?.existObjectId)

                                    const circleLayer = L.circleMarker(latlng, { // Daire oluşturuluyor
                                        radius: 5, // Dairenin yarıçapı
                                        color: 'black', // Dairenin kenar rengi
                                        fillColor: color, // Dairenin dolgu rengi
                                        fillOpacity: 1, // Dolgu opaklığı,
                                    });
                                    // const circleLayer = L.circle(latlng, 0.1, {color: 'black', fillColor: '#ffff00', fillOpacity: 0.5})
                                    circleLayer.bringToFront()
                                    return circleLayer
                                }
                            },
                            onEachFeature: (feature, layer) => {
                                layer.on('mouseover', function (e) {
                                    let key = Object.keys(feature.properties).find(x => x.toLowerCase().includes('id') && feature.properties[x])
                                    if(!key)
                                        key = Object.keys(feature.properties).find(x => feature.properties[x])

                                    let html = ReactDOMServer.renderToString(
                                        <ShapeTooltip
                                            labels={layerRow?.labels || [key]}
                                            feature={feature}
                                        />
                                    );

                                    layer.bindTooltip(L.tooltip({}).setContent(html), {sticky: true}).openTooltip();
                                });

                                layer.on('click', function (e) {
                                    const latlng = e.latlng;
                                    let html = ReactDOMServer.renderToString(
                                        <ShapeItem
                                            feature={feature}
                                        />
                                    );

                                    const content = `<div style="max-height: 380px; overflow-y: auto">${html}</div>`
                                    L.popup({autoPan: true})
                                        .setLatLng(latlng)
                                        .setContent(content)
                                        .openOn(map);
                                });
                            }
                        }).addTo(labelGroup)
                        labelGroup.bringToFront()
                    }
                    else if(layerRow.ext?.toLowerCase() === 'tif') {
                        const geo_data = await parseGeoraster(layerRow?.fileData)
                        layerRow.data = geo_data
                        const georaster = JSON.parse(JSON.stringify(layerRow.data))
                        const hillshade = applyHillshade(georaster)

                        let rows = 1
                        let columns = 1

                        const tifLayerColor = new GeoRasterLayer({
                            georaster: georaster,
                            opacity: mapContext[type]?.terrainLayers?.opacity_size,
                            pixelValuesToColorFn: (pixelValues) => {
                                if(columns === georaster.width) {
                                    rows++;
                                    columns = 1
                                }
                                else {
                                    columns++
                                }

                                const pixelValue = pixelValues[0];
                                if (pixelValue === 0)
                                    return null;

                                const hillshadeValue = applyHillshade(georaster, rows-1, columns-1);
                                const color = pixelValueToColor(pixelValue, georaster?.mins[0], georaster?.maxs[0]);
                                const [r,g,b]  = applyShadeToColor(color, hillshadeValue);
                                const hex = (1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1).toUpperCase();
                                return `#${hex}`;
                            },
                            resolution:  mapContext[type]?.terrainLayers?.resolution_size // optional parameter for adjusting display resolution
                        });

                        const hillshades = []
                        for(let r=0; r < georaster.height; r++) {
                            for(let c = 0 ; c < georaster.width; c++) {
                                hillshades.push(applyHillshade(
                                    georaster, 
                                    r, 
                                    c, 
                                    mapContext[type]?.terrainLayers?.gray_z_factor || 1,
                                    mapContext[type]?.terrainLayers?.azimuth || 315,
                                    mapContext[type]?.terrainLayers?.altitude || 45
                                ));
                            }
                        }


                        const canvas = document.createElement('canvas');
                        canvas.width = georaster.width;
                        canvas.height = georaster.height;
                        const ctx = canvas.getContext('2d');
                        const imageData = ctx.createImageData(georaster.width, georaster.height);

                        for (let i = 0; i < hillshades.length; i++) {
                            imageData.data[4 * i] = hillshades[i];
                            imageData.data[4 * i + 1] = hillshades[i];
                            imageData.data[4 * i + 2] = hillshades[i];
                            imageData.data[4 * i + 3] = 255 * (mapContext[type]?.terrainLayers?.gray_opacity_size);  // Opaklık (alpha)
                        }

                        ctx.putImageData(imageData, 0, 0);
                        const hillshadeUrl = canvas.toDataURL();

                        const tifLayerGray = L.imageOverlay(hillshadeUrl, tifLayerColor.getBounds(), {});

                        map.fitBounds(tifLayerGray.getBounds());
                        map.fitBounds(tifLayerColor.getBounds());


                        tifLayerGray.addTo(map);
                        tifLayerColor.addTo(map);

                        window.projectShapes[v4()] = tifLayerColor;
                        window.projectShapes[v4()] = tifLayerGray;
                    }
                }
                catch (exp) {
                    console.log(exp)
                }
            }
        }
    }

    const loadRiverStream = (zoomChanged) => {
        // zoom degistiginde butun riveri tekrar render etme
        if(mapObjects.current.river && !zoomChanged)
        {
            mapObjects.current.river.remove()
            mapObjects.current.river = null
        }

        if(modelLayers.includes('Flow Direction'))
        {
            // const freq = `${(mapContext[type]?.flowArrow?.freq / 3.28)}m` || '50m'
            const zoom = mapContext[type]?.zoom || 18
            const zoomSize = 25 - zoom
            const verticalDistance = getVerticalDistance()
            let freq_dist = verticalDistance / mapContext[type]?.flowArrow?.flow_count
            let freq = `${freq_dist < 100 ? 100 : freq_dist}m` || '500m'
            let size = `${mapContext[type]?.flowArrow?.flow_size + zoomSize}px` || '15px'

            if(zoomChanged && mapObjects.current.river) {
                mapObjects.current.river.arrowheads({frequency: freq, fill: false, size: size, color: '#04d9ff'}).addTo(map);
            }
            else {
                mapObjects.current.river = L.polyline(mapData.reach_xy, { color: 'blue' }).arrowheads({frequency: freq, fill: false, size: size, color: '#04d9ff'}).addTo(map);
            }
        }
        else {
            if(!zoomChanged) {
                mapObjects.current.river = L.polyline(mapData.reach_xy, { color: 'blue' }).addTo(map);
            }
        }
    }

    const setRS2MapCenter = async (zoom) => {
        let mapRS = mapData?.cross_sections?.find(x => x?.cross_section && parseFloat(x?.cross_section?.toString()) === parseFloat(selectedRS?.cross_section?.toString()))
        let xy = mapRS?.center

        if(!mapRS)
        {
            mapRS = mapData?.structures?.find(x => x?.cross_section && parseFloat(x?.cross_section?.toString()) === parseFloat(selectedRS?.cross_section?.toString()))

            xy = mapRS?.xy_list[0];
            if(mapRS?.xy_list[0]?.xy) {
                xy = mapRS?.xy_list[0]?.xy
            }
        }

        if(!xy) {
            await fullExtend()
            return
        }

        const center = getCenter(xy)
        map.setView(center, zoom)
    }

    const loadStructures = () => {
        if(mapObjects.current.structureLayer?.remove)
        {
            mapObjects.current.structureLayer.remove()
            mapObjects.current.structures = []
        }


        mapObjects.current.structureLayer = L.layerGroup()

        mapData?.structures?.forEach(cs => {
            cs?.xy_list?.forEach(item => {
                const xy = item.xy || []

                const isSelected = HecRasHelper.isCrossSectionMatch(
                    selectedRS?.cross_section,
                    cs.cross_section,
                    cs.cross_section_value
                );

                const polygon = L.polygon(xy || [], {
                    color: isSelected ? 'red' : getColor(cs.cross_section, 'structure', tile.structure),
                    fillColor: 'gray',
                    weight: 5
                }).addTo(mapObjects.current.structureLayer)
                polygon.cross_section = cs.cross_section
                polygon.search = cs.cross_section
                mapObjects.current.structures.push(polygon)
            })
        })

        mapObjects?.current?.structureLayer?.addTo(map)
        mapObjects?.current?.structures?.forEach(x => x.bringToBack())
    }

    const loadMultipleOpeningLines = () => {
        if(mapObjects.current.multipleOpeningLinesLayer?.remove)
        {
            mapObjects.current.multipleOpeningLinesLayer.remove()
            mapObjects.current.multipleOpeningLines = []
        }

        if(!modelLayers.includes('Multiple Opening'))
            return;

        mapObjects.current.multipleOpeningLinesLayer = L.layerGroup()

        mapData?.multiple_openings?.forEach(opening => {
            opening?.opening_xy_list?.forEach(xy => {
                mapObjects.current.multipleOpeningLines.push(L.polyline(xy || [], { color: 'red', weight: 1, dashArray: '3, 3', dashOffset: '5' }).addTo(mapObjects.current.multipleOpeningLinesLayer))
            })
        })

        mapObjects.current.multipleOpeningLinesLayer.addTo(map)
    }

    const loadFlowPaths = (profile) => {
        if(mapObjects.current.flow_path_left?.remove)
        {
            mapObjects.current.flow_path_left.remove()
            mapObjects.current.flow_path_left = null
        }

        if(mapObjects.current.flow_path_right?.remove)
        {
            mapObjects.current.flow_path_right.remove()
            mapObjects.current.flow_path_right = null
        }

        if(!modelLayers.includes('Flow Path'))
            return;

        const item = mapData?.flow_paths?.find(x => x.profile === profile?.target)
        if(!item)
            return;


        mapObjects.current.flow_path_left = L.polyline(item?.left_coords || [], { color: '#33CCFF', weight: 1 }).addTo(map);
        mapObjects.current.flow_path_right = L.polyline(item?.right_coords || [], { color: '#33CCFF', weight: 1 }).addTo(map);
    }

    const loadFloodExtends = (profile) => {
        if(mapObjects.current.floodExtendsLayer?.remove)
        {
            mapObjects.current.floodExtendsLayer.remove()
            mapObjects.current.floodExtends = []
        }

        if(!modelLayers.includes('Flood Extent'))
            return;

        mapObjects.current.floodExtendsLayer = L.layerGroup()

        const floodExtends = _.groupBy(mapData?.flood_extends, (x) => x.profile)
        Object.keys(floodExtends)?.forEach(key => {
            if(profile?.target === key) {
                floodExtends[key].forEach(item => {
                    mapObjects.current.floodExtends.push(L.polyline(item?.xy || [], { color: 'blue', weight: 2, }).addTo(mapObjects.current.floodExtendsLayer))
                })
            }
        })

        mapObjects.current.floodExtendsLayer.addTo(map)
    }

    const loadBlockObstr = () => {
        if(mapObjects.current.blockObstLayer?.remove)
        {
            mapObjects.current.blockObstLayer.remove()
            mapObjects.current.blockObst = []
        }

        if(!modelLayers.includes('Blocked Obstruction'))
            return;

        mapObjects.current.blockObstLayer = L.layerGroup()

        mapData?.cross_sections?.forEach(cs => {
            if(cs.type === 'cross_section') {
                if(cs?.block_obstr?.length > 0) {
                    for (const blockObstr of cs.block_obstr) {
                        mapObjects.current.blockObst.push(L.polyline(blockObstr, { color: 'black', weight: 2, }).addTo(mapObjects.current.blockObstLayer))
                    }
                }
            }
        })

        mapObjects.current.blockObstLayer.addTo(map)
    }

    // Per cross-section River Station Point — the point where the reach
    // polyline crosses the XS cut-line (cs.Intersection.intersect_chord on
    // the Python side, exposed as cross_section.center in lat/lng). Toggle
    // lives in the Model Layers popover; default-on for new users.
    const loadRiverStationPoints = () => {
        if(mapObjects.current.riverStationPointLayer?.remove) {
            mapObjects.current.riverStationPointLayer.remove()
        }
        mapObjects.current.riverStationPoints = []

        if(!modelLayers.includes('River Station Point'))
            return;

        const group = L.layerGroup()
        mapData?.cross_sections?.forEach(cs => {
            const center = cs?.center?.[0]
            if(!center || center.length < 2) return;
            const marker = L.circle([center[0], center[1]], 0.5, {
                color: 'blue',
                fillColor: 'blue',
                fillOpacity: 0.5,
            })
            marker.bindTooltip(`River Station ${cs.cross_section}`, {sticky: true})
            marker.addTo(group)
            mapObjects.current.riverStationPoints.push(marker)
        })

        mapObjects.current.riverStationPointLayer = group
        group.addTo(map)
    }

    const getSquareFromCenter = (center, R) => {
        const centerLat = center[0]
        const centerLng = center[1]
        const correction_factor = Math.cos(centerLat * Math.PI / 180);

        const topLat = centerLat + (R / 111139);
        const bottomLat = centerLat - (R / 111139);
        const leftLng = centerLng - (R / (111139 * correction_factor));
        const rightLng = centerLng + (R / (111139 * correction_factor));

        const square = {
            top_left: { lat: topLat, lng: leftLng },
            top_right: { lat: topLat, lng: rightLng },
            bottom_left: { lat: bottomLat, lng: leftLng },
            bottom_right: { lat: bottomLat, lng: rightLng }
        };

        return [square.top_left, square.top_right, square.bottom_right, square.bottom_left]
    }

    const loadBoundaryTable = () => {
        if(mapObjects.current.downstreamBoundary?.remove)
        {
            mapObjects.current.downstreamBoundary.remove()
        }

        if(!modelLayers.includes('Boundary Condition'))
            return;

        const boundary = mapData?.boundary
        if(boundary) {
            if(boundary?.chords?.length < 1)
                return;

            let R = (getVerticalDistance()/40)
            R = R*mapContext[type]?.flowArrow?.boundary_size/100

            const square_coords = getSquareFromCenter(boundary?.chords[0], R)
            const square = L.polygon(square_coords, {
                color: '#04d9ff',     // Çokgenin kenar rengi
                fillColor: '#f00', // Çokgenin iç dolgu rengi
                fillOpacity: 0.0,   // Çokgenin iç dolgu opaklığı
                weight: 5
            })

            mapObjects.current.downstreamBoundary = square.on('click', (e) => {
                const latlng = e.latlng;
                createLeafletPopup({
                    L,
                    content: (<BoundaryTable data={boundary?.data} />),
                    contentStyle: {
                        maxHeight: 600,
                        overflowY: 'auto'
                    },
                    properties: {autoPan: true, minWidth: HecRasHelper.getWidth(40)},
                    latlng,
                    map
                })
            })

            mapObjects.current.downstreamBoundary.addTo(map)
        }
    }

    const getVerticalDistance = () => {
        const northBound = map.getBounds().getNorth();
        const southBound = map.getBounds().getSouth();
        return L.latLng(northBound, 0).distanceTo(L.latLng(southBound, 0));
    }

    const loadFlowChangeTable = () => {
        if(mapObjects.current.flowChangeLayer?.remove)
        {
            mapObjects.current.flowChangeLayer.remove()
            mapObjects.current.flowChanges = []
        }

        if(!modelLayers.includes('Flow Change Location'))
            return;

        // Haritanın kuzey ve güney sınırlarını alın
        const vDist = getVerticalDistance()

        mapObjects.current.flowChangeLayer = L.layerGroup()
        mapData?.flow_change_locations?.forEach(fl => {
            if(fl?.chords?.length < 1)
                return;

            const circle = L.circle(fl?.chords[0], {
                color: '#04d9ff',      // Çemberin kenar rengi
                fillColor: '#f03', // Çemberin iç dolgu rengi
                fillOpacity: 0.0,  // Çemberin iç dolgu opaklığı
                radius: ((vDist/20)/4)*mapContext[type]?.flowArrow?.flow_change_size/50,
                weight: 5
            })

            circle.on('click', (e) => {
                const latlng = e.latlng;
                createLeafletPopup({
                    L,
                    content: (<FlowChangeTable data={mapData?.flow_change_locations || []} profiles={mapData?.profiles?.map(x => x.targetName)} selectedCS={fl?.cross_section} />),
                    contentStyle: {
                        maxHeight: 600,
                        overflowY: 'auto'
                    },
                    properties: {autoPan: true, minWidth: HecRasHelper.getWidth(17+mapData?.profiles?.length*10)},
                    latlng,
                    map
                })
            })

            circle.addTo(mapObjects.current.flowChangeLayer)
        })
        mapObjects.current.flowChangeLayer.addTo(map)
    }

    const loadTexts = () => {
        if(mapObjects.current.textLayer?.remove)
        {
            mapObjects.current.textLayer.remove()
            mapObjects.current.crossSectionTexts = []
            mapObjects.current.structureTexts = []
        }

        // mapObjects.current.textLayer = L.inflatableMarkersGroup({
        //     iconCreateFunction: function (icon) {return L.divIcon({html: `<div style="color: ${tile.textColor}"></div>`, iconSize: [0,0]});}
        // }).addTo(map);

        mapObjects.current.textLayer = L.markerClusterGroup({
            zoomToBoundsOnClick: true,
            iconCreateFunction: function(cluster) {
                return L.divIcon({ html: cluster.getAllChildMarkers()[0]?.options?.icon?.options?.html, className: 'dummy',});
            }
        }).addTo(map);

        mapData?.cross_sections?.forEach(cs => {
            let cs_text = `<div style="color: ${getColor(cs?.cross_section, 'text', tile.textColor)}">${cs?.cross_section}</div>`
            if(cs?.ratio && parseFloat(cs?.ratio?.toFixed(2)) !== 1) {
                let color = 'red'
                let skew_r = (1/Math.cos(parseFloat(cs?.skew) * Math.PI / 180)).toPrecision(3)
                if(skew_r === parseFloat(cs?.ratio).toPrecision(3)) {
                    color = 'green'
                }

                cs_text = `<div style="color: ${getColor(cs?.cross_section, 'text', tile.textColor)}">${cs?.cross_section}<br/><div style="color: ${color};">r=${cs.ratio?.toFixed(2)}</div></div>`
            }

            const text = L.divIcon({
                className: 'dummy',
                html: cs_text,
                iconSize: [100, 30], // Metnin boyutu
            })

            const marker = L.marker(cs.xy[0], {icon: text}).addTo(mapObjects.current.textLayer);
            marker.cross_section = cs.cross_section
            marker.on('click', (e) => {
                const latlng = e.latlng;
                createLeafletPopup({
                    L,
                    content: (<CrossSectionWindow riverStation={{base_ui_data: cs?.cs_ui, base_title: cs?.cross_section}} />),
                    contentStyle: {
                        maxHeight: 800,
                        overflowY: 'auto'
                    },
                    properties: {autoPan: true, maxWidth: 760},
                    latlng,
                    map
                })
            })
            mapObjects.current.crossSectionTexts.push(marker)
        })

        mapData?.structures?.forEach(cs => {
            cs?.xy_list?.forEach(item => {
                const xy = item.xy || []

                const str_center_x = (xy?.map(x => x[0]).reduce((a, b) => a + b))/xy?.length
                const str_center_y = (xy?.map(x => x[1]).reduce((a, b) => a + b))/xy?.length

                const text_marker = L.marker([str_center_x, str_center_y], {
                    icon: L.divIcon({
                        className: 'dummy',
                        html: ReactDOMServer.renderToString(<StructureName textColor={getColor(cs?.cross_section, 'text', tile.textColor)} selectedRS={selectedRS?.cross_section} cs={cs} strItem={item} />), // Buraya istediğiniz metni ekleyin
                        iconSize: [100, 30], // Metnin boyutu
                    }),
                    search: cs.cross_section
                }).addTo(mapObjects.current.textLayer)
                text_marker.cs_data = cs
                text_marker.on('click', (e) => {
                    const latlng = e.latlng;
                    let content = ``
                    if(cs.typeName === 'Culvert') {
                        content = (
                            <div>
                                <StructureInfoTabs
                                    inf01={<CulvertTable r={cs?.str_table} />}
                                    inf02={<CulvertInfoTable r={cs?.str_table} />}
                                />
                            </div>
                        );
                    }
                    else if(cs.typeName === 'Bridge') {
                        content = (
                            <div>
                                <StructureInfoTabs
                                    inf01={<BridgeTable r={cs?.str_table} />}
                                    inf02={<BridgeInfoTable r={cs?.str_table} />}
                                />
                            </div>
                        );
                    }
                    else if(cs.typeName === 'InlineStructure') {
                        content = (
                            <div>
                                <InlineStructureInfoTable r={cs?.str_table} />
                            </div>
                        );
                    }

                    createLeafletPopup({
                        L,
                        content,
                        contentStyle: {
                            overflowY: 'auto',
                            minWidth: HecRasHelper.getWidth(58)
                        },
                        properties: {autoPan: true, maxWidth: HecRasHelper.getWidth(80)},
                        latlng,
                        map
                    })
                })

                mapObjects.current.structureTexts.push(text_marker)
            })
        })
    }

    const loadCrossSections = () => {
        if(mapObjects.current.crossSectionLayer?.remove)
        {
            mapObjects.current.crossSectionLayer.remove()
            mapObjects.current.crossSections = []
        }

        mapObjects.current.crossSectionLayer = L.layerGroup()

        mapData?.cross_sections?.forEach(cs => {
            if(cs.type === 'cross_section') {
                const isSelected = HecRasHelper.isCrossSectionMatch(
                    selectedRS?.cross_section,
                    cs.cross_section,
                    cs.cross_section_value
                );

                const polyline = L.polyline(cs?.xy, { color: isSelected ? 'red' : getColor(cs.cross_section, 'cross_section', tile.csColor), weight: 1, }).addTo(mapObjects.current.crossSectionLayer)
                polyline.cross_section = cs.cross_section
                polyline.search = cs.cross_section
                polyline.on('click', () => {

                })
                mapObjects.current.crossSections.push(polyline)
            }
        })

        mapObjects.current.crossSectionLayer.addTo(map)
    }

    const loadIneffs = () => {
        if(mapObjects.current.ineffLayer?.remove)
        {
            mapObjects.current.ineffLayer.remove();
            mapObjects.current.ineffs = []
        }

        if(!modelLayers.includes('Ineffective Area'))
            return;

        if(map.getZoom() < 17)
            return

        mapObjects.current.ineffLayer = L.layerGroup();
        mapData?.cross_sections?.forEach(cs => {
            if(cs.type === 'cross_section') {
                cs?.ineffs?.forEach(ineff => {
                    const ineff_icon = L.icon({
                        iconUrl: '/icons/ineff_icon.png', // İkon resmi dosya yolu
                        iconSize: [12, 12], // İkon boyutu
                    });
                    mapObjects.current.ineffs.push(L.marker(ineff?.xy, { icon: ineff_icon }).addTo(mapObjects.current.ineffLayer))
                })
            }
        })

        mapObjects.current.ineffLayer.addTo(map)
    }

    const isLoadMannings = () => {
        if(!modelLayers.includes('Mannings n'))
            return false;

        if(mapContext[type]?.zoom < 17)
            return false

        return true
    }

    const loadMannings = () => {
        if(mapObjects.current.manningsLayer?.remove)
        {
            mapObjects.current.manningsLayer.remove();
            mapObjects.current.mannings = []
        }

        if(mapObjects.current.manningsTextLayer?.remove)
        {
            mapObjects.current.manningsTextLayer.remove();
            mapObjects.current.manningsTextLayer = []
        }

        if(!isLoadMannings())
            return

        mapObjects.current.manningsLayer = L.layerGroup().addTo(map);
        mapObjects.current.manningsTextLayer = L.inflatableMarkersGroup({
            iconCreateFunction: function (icon) {return L.divIcon({html: `<div style="color: ${tile.textColor}"></div>`, iconSize: [0,0]});}
        }).addTo(map);

        mapData?.cross_sections?.forEach(cs => {
            if(cs.type === 'cross_section') {
                cs.manns?.forEach(mann => {
                    if(!mann)
                        return

                    mapObjects.current.mannings.push(L.polyline(mann, { color: tile.textColor, weight: 1, }).addTo(mapObjects.current.manningsLayer))
                })

                cs?.manns_text?.forEach(mann_text => {
                    mapObjects.current.manningsTexts.push(
                        L.marker(mann_text?.chord?.xy, {
                            icon: L.divIcon({
                                className: 'dummy',
                                html: `<div style="color:${tile.textColor}; ">n: ${mann_text?.text}</div>`, // Buraya istediğiniz metni ekleyin
                                iconSize: [48, 20], // Metnin boyutu
                                iconAnchor: [0, -15]
                            })
                        }).addTo(mapObjects.current.manningsTextLayer)
                    )
                })
            }
        })
    }

    const loadBankStations = () => {
        if(mapObjects.current.banksLayer?.remove)
        {
            mapObjects.current.banksLayer.remove();
            mapObjects.current.banks = []
        }

        if(!modelLayers.includes('Bank Station'))
            return;

        mapObjects.current.banksLayer = L.layerGroup();
        mapData?.cross_sections?.forEach(cs => {
            if(cs.type === 'cross_section') {
                cs?.banks?.forEach(b => {
                    const bank = L.circle(b?.xy, 0.5, {color: 'red', fillColor: 'red', fillOpacity: 0.5}).addTo(mapObjects.current.banksLayer)

                    const mouseOver = (e) => {
                        const latlng = e.latlng;
                        createLeafletPopup({
                            L,
                            content: (
                                <ResultTable>
                                    <ResultRow>
                                        <ResultHeaderCell style={{textAlign: 'left'}}>RS</ResultHeaderCell>
                                        <ResultBodyCell style={{textAlign: 'left',}}>{cs?.cross_section}</ResultBodyCell>
                                    </ResultRow>
                                    <ResultRow>
                                        <ResultHeaderCell style={{textAlign: 'left'}}>Station</ResultHeaderCell>
                                        <ResultBodyCell style={{textAlign: 'left'}}>{b?.station}</ResultBodyCell>
                                    </ResultRow>
                                    <ResultRow>
                                        <ResultHeaderCell style={{textAlign: 'left'}}>Elevation</ResultHeaderCell>
                                        <ResultBodyCell style={{textAlign: 'left'}}>{b?.elev}</ResultBodyCell>
                                    </ResultRow>
                                </ResultTable>
                            ),
                            contentStyle: {
                                maxHeight: 100,
                                overflowY: 'auto'
                            },
                            properties: {autoPan: true, maxWidth: 200},
                            latlng,
                            map
                        })
                    }
                    bank.on('click', mouseOver)
                    // bank.on('mouseover', mouseOver)

                    mapObjects.current.banks.push(bank)
                })
            }
        })
        mapObjects.current.banksLayer.addTo(map)
    }

    const loadLayers = (zoomChanged) => {
        if(!map)
            return

        if(mapObjects.current.loadLayerTimeout) {
            clearTimeout(mapObjects.current.loadLayerTimeout)
        }

        mapObjects.current.loadLayerTimeout = setTimeout(() => {
            loadRiverStream(zoomChanged)
            loadStructures()
            loadCrossSections()
            loadMultipleOpeningLines()
            loadFloodExtends(profile || mapData.profiles[0])
            loadFlowPaths(profile || mapData.profiles[0])
            loadBlockObstr()
            loadBoundaryTable()
            loadFlowChangeTable()
            loadTexts()
            loadIneffs()
            loadMannings()
            loadBankStations()
            loadRiverStationPoints()
        }, 200)
    }

    const clearLayers = () => {
        // During teardown (Map View -> Messages, or react-leaflet unmounting the
        // map) a layer's _map may already be null. leaflet-arrowheads then throws
        // "Cannot read properties of null (reading '_targets')" while cleaning up
        // an arrowheaded polyline (river / streamArrow). Guard every removal: skip
        // already-detached layers, snapshot the set so we never mutate while
        // iterating, and swallow plugin teardown errors.
        const safeRemove = (layer) => {
            try {
                if(layer?._map) layer.remove()
            } catch (e) { /* already detached during teardown */ }
        }

        if(map) {
            try {
                const layers = []
                map.eachLayer((layer) => layers.push(layer))
                layers.forEach((layer) => {
                    try {
                        if(layer?._map) map.removeLayer(layer)
                    } catch (e) { /* arrowheads child can be detached already */ }
                })
            } catch (e) { /* map already torn down */ }
        }

        safeRemove(mapObjects.current.tile)
        safeRemove(mapObjects.current.river)
        safeRemove(mapObjects.current.streamArrow)
        safeRemove(mapObjects.current.banksLayer)
        safeRemove(mapObjects.current.manningsLayer)
        safeRemove(mapObjects.current.manningsTextLayer)
        safeRemove(mapObjects.current.ineffLayer)
        safeRemove(mapObjects.current.crossSectionLayer)
        safeRemove(mapObjects.current.crossSectionTextLayer)
        safeRemove(mapObjects.current.flowChangeLayer)
        safeRemove(mapObjects.current.downstreamBoundary)
        safeRemove(mapObjects.current.blockObstLayer)
        safeRemove(mapObjects.current.structureLayer)
        safeRemove(mapObjects.current.structureTextLayer)
        safeRemove(mapObjects.current.multipleOpeningLinesLayer)
        safeRemove(mapObjects.current.floodExtendsLayer)
        safeRemove(mapObjects.current.searchLayer)
        safeRemove(mapObjects.current.textLayer)
    }

    const onContextMenuMap = async (e) => {
        const elements = document.getElementsByClassName('leaflet-control-coord-projection')
        if(elements?.length > 0) {
            const coordDiv = elements[0]
            const text = coordDiv.innerText.split('|').map(x => x?.trim())?.join('\t')
            await navigator.clipboard.writeText(`${text}\n${e?.latlng?.lat?.toFixed(6)}\t${e?.latlng?.lng?.toFixed(6)}`)
            // Modal.info({
            //     title: ``,
            //     content: (
            //         <>
            //
            //         </>
            //     ),
            //     footer: null
            // })
        }
    }

    const onZoomEnd = (e) => {
        dispatchProject({
            type: AppActions.SET_MAP_ZOOM,
            data: {zoom: map.getZoom(), type}
        })
        // Save to sharedView for B/C sync (using MapSyncContext)
        setSharedView(map.getZoom(), map.getCenter())
    }

    const onMoveEnd = () => {
        // Save to sharedView for B/C sync (using MapSyncContext)
        setSharedView(map.getZoom(), map.getCenter())
    }

    useEffect(() => {
        if(mapContext[type].update !== mapContext[type].prevUpdate) {
            mapContext[type].prevUpdate = mapContext[type].update
            loadLayers(false)
            onChangeLayers()
        }
    }, [mapContext[type].update, highlightSurvey, modelLayers]);

    // LayerSelect Control'ünü güncelle
    useEffect(() => {
        if(mapObjects.current.layerSelectRoot) {
            mapObjects.current.layerSelectRoot.render(
                <LayerSelectLeaflet
                    type={type}
                    projectLayers={projectLayers}
                    onProjectLayerChange={onProjectLayerChange}
                    riverBounding={riverBoundingCoords}
                    mapContext={mapContext}
                    dispatchProject={dispatchProject}
                    ShapeTableComponent={ShapeTable}
                    openModal={openModal}
                    userSettings={user?.settings}
                    user={user}
                    setSettings={setSettings}
                />
            );
        }
    }, [mapContext, projectLayers, riverBoundingCoords, type]);

    // Update ProjectionSelect Control when projection changes
    useEffect(() => {
        if(mapObjects.current.projectionSelectRoot) {
            mapObjects.current.projectionSelectRoot.render(
                <ProjectionSelect
                    projectProjection={projection}
                    activeProjection={activeProjection}
                    onProjectionChange={setActiveProjection}
                    userPreference={userPreferenceProjection}
                />
            );
        }
    }, [activeProjection, projection, userPreferenceProjection]);


    useEffect(() => {
        if(filter?.us || filter?.ds) {
            if(!map)
                return

            loadStructures()
            loadCrossSections()
            loadTexts()
        }
    }, [filter?.us, filter?.ds]);
    //
    useEffect(() => {
        const event = new CustomEvent('change-project-info', {
            detail: {
                [type]: {
                    ...(projectInfo || {}),
                    color: tile.textColor
                }
            }
        });
        window.dispatchEvent(event)
    }, [mapContext[type].update, tile, projectInfo]);
    //
    const runFullExtend = (e) => {
        if(e?.detail?.type === type) {
            setFullExtendEvent(v4())
        }
    }

    // Update typeRef when type changes
    useEffect(() => {
        typeRef.current = type
    }, [type])

    // When becoming visible, apply sharedView to map and invalidateSize
    const prevVisibleRef = useRef(isVisible)
    useEffect(() => {
        // Only run when transitioning from hidden to visible
        if (isVisible && !prevVisibleRef.current && map) {
            setTimeout(() => {
                map.invalidateSize()
                // Apply shared zoom/center from MapSyncContext only if valid
                const sharedView = getSharedView()
                if (sharedView?.zoom && sharedView?.zoom > 0 && sharedView?.center) {
                    map.setView(sharedView.center, sharedView.zoom, { animate: false })
                }
            }, 50)
        }
        prevVisibleRef.current = isVisible
    }, [isVisible])

    // Initialize and update effective projection
    useEffect(() => {
        const initProjection = async () => {
            const effProj = await getEffectiveProjection()
            setActiveProjection(effProj)
        }
        initProjection()
    }, [projection, userPreferenceProjection])

    // Update MouseCoord when projection changes
    useEffect(() => {
        if (mouseCoordRef.current && activeProjection?.text) {
            mouseCoordRef.current.updateProjection(activeProjection.text, activeProjection.name, activeProjection.isProject)
        }
    }, [activeProjection])

    // Keyboard listener for B/C/S keys
    useEffect(() => {
        if (!map || !onTypeChange || isSideBySide) return

        const handleKeyDown = (e) => {
            // Skip if user is typing in an input field
            if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable) {
                return
            }

            // Skip if any modifier key is pressed (Ctrl, Alt, Shift, Meta)
            if (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey) {
                return
            }

            const key = e.key.toLowerCase()
            if (key === 'b') {
                onTypeChange('base')
            } else if (key === 'c' && hasCompareData) {
                onTypeChange('compare')
            } else if (key === 's' && hasCompareData) {
                onTypeChange('sidebyside')
            }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => {
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [map, onTypeChange, hasCompareData, isSideBySide])

    // Update MapTypeSwitch button when type changes
    useEffect(() => {
        if (mapObjects.current.mapTypeSwitchRoot && onTypeChange) {
            mapObjects.current.mapTypeSwitchRoot.render(
                <MapTypeSwitchButton 
                    currentType={buttonType} 
                    onTypeChange={onTypeChange} 
                    hasCompareData={hasCompareData}
                />
            )
        }
    }, [buttonType, hasCompareData])

    useEffect(() => {
        if(map && !isReady.current) {
            isReady.current = true

            loadToolbar()
            loadPlugins()

            map.on('moveend', onMoveEnd)
            map.on('zoomend', onZoomEnd)
            map.on('contextmenu', onContextMenuMap)

            // Save initial view to sharedView for B/C sync (using MapSyncContext)
            if (isVisible) {
                setSharedView(map.getZoom(), map.getCenter())
            }

            window.addEventListener('resize', handleResize);
            window.addEventListener('full-extend', runFullExtend);

            return () => {
                window.removeEventListener('resize', handleResize);
                window.removeEventListener('full-extend', runFullExtend);
                map.off('moveend', onMoveEnd)
                map.off('zoomend', onZoomEnd)

                dispatchProject({
                    type: AppActions.SET_MESSAGE_TOOLBAR_ITEM,
                    data: {toolbar: null}
                })

                clearLayers()
            };
        }

        return () => {
            if(map) {
                map.off('contextmenu', onContextMenuMap)
            }
        }
    }, [map]);

    useEffect(() => {
        if(fullExtendEvent) {
            fullExtend()
        }
    }, [fullExtendEvent]);

    useEffect(() => {
        if(mapData && map && profile?.target) {
            loadFloodExtends(profile)
            loadFlowPaths(profile)
        }
    }, [profile?.target]);

    useEffect(() => {

        if(mapData && map) {
            if(mapObjects.current.tile) {
                map.removeLayer(mapObjects.current.tile)
                mapObjects.current.tile = null
            }

            // White background için beyaz GridLayer oluştur
            if(tile.isBlank) {
                const WhiteLayer = L.GridLayer.extend({
                    createTile: function() {
                        const tile = document.createElement('canvas');
                        const size = this.getTileSize();
                        tile.width = size.x;
                        tile.height = size.y;
                        const ctx = tile.getContext('2d');
                        ctx.fillStyle = 'white';
                        ctx.fillRect(0, 0, size.x, size.y);
                        return tile;
                    }
                });
                mapObjects.current.tile = new WhiteLayer({maxZoom: 25})
                mapObjects.current.tile.addTo(map)
            } else {
                mapObjects.current.tile = window.L.tileLayer(tile.url, tile.options || {maxZoom: 35})
                mapObjects.current.tile.addTo(map)
            }

            loadLayers(false)
        }
    }, [tile, map]);

    useEffect(() => {
        if(mapContext[type]?.zoom && map && mapData) {
            loadLayers(true)
        }

    }, [mapContext[type]?.zoom]);

    useEffect(() => {
        if(map && mapData) {
            if(selectedRS?.cross_section)
            {
                loadLayers(false)
                setRS2MapCenter(!prevSelectedRS.current ? 18 : map.getZoom())
                prevSelectedRS.current = selectedRS?.cross_section
            }
            else {
                fullExtend()
            }
        }
    }, [selectedRS?.cross_section, map]);


    useEffect(() => {
        if(map && mapData) {
            loadLayers(false)
        }
    }, [updateKey]);


    useEffect(() => {
        const containerId = isSideBySide ? `map-container-tab-${type}` : 'map-container-tab'
        const mapContainer = document.getElementById(containerId)
        if(mapContainer && map) {
            try {
                if (typeof size.width === 'number') mapContainer.style.width = `${size.width}px`;
                if (typeof size.height === 'number') mapContainer.style.height = `${size.height}px`;
                map.invalidateSize();
            } catch (e) {
                // Ignore invalidateSize errors during side-by-side initialization
            }
        }
    }, [size, type, isSideBySide]);

    // Generate unique container ID for side-by-side mode
    const containerId = isSideBySide ? `map-container-tab-${type}` : 'map-container-tab'

    return (
        <div key={`map-tab-${type}`} style={{width: '100%', height: '100%'}}>
            {/* FEMA Loading Progress Modal */}
            {femaProgress && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.45)',
                    zIndex: 1000,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        background: 'white',
                        borderRadius: 8,
                        padding: '20px 24px',
                        minWidth: 320,
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                    }}>
                        <div style={{ fontSize: 16, fontWeight: 500, marginBottom: 16 }}>
                            Loading FEMA NFHL Data...
                        </div>
                        <Progress 
                            percent={Math.round((femaProgress.current / femaProgress.total) * 100)} 
                            status="active" 
                        />
                        <div style={{ marginTop: 12, fontSize: 13, color: '#666' }}>
                            <div>Grid cells: <b>{femaProgress.current}</b> / {femaProgress.total} ({femaProgress.numCols}x{femaProgress.numRows})</div>
                            <div>Features found: <b>{femaProgress.features}</b></div>
                            {femaProgress.errors > 0 && <div style={{ color: '#ff4d4f' }}>Errors: {femaProgress.errors}</div>}
                        </div>
                    </div>
                </div>
            )}
            <MapContainer
                id={containerId}
                center={[51.505, -0.09]}
                zoom={mapContext[type]?.zoom}
                zoomSnap={0.1}
                popupMovable={true}
                style={{ height: size.height, width: size.width, backgroundColor: 'white' }}
                whenReady={(_map) => {
                    setMap(_map.target)
                    if (onMapReady) {
                        onMapReady(_map.target)
                    }
                }}
            >

            </MapContainer>
        </div>
    )
}